<template>
  <div class="planassignMain" ref="planassignMain">
    <div class="planDragCover" :style="{
      'z-index': '0',
      'pointer-events': ((planTopData['tableMouseMove'] || planBottomData['vehicleItemMouseMove']) ? '' : 'none'),
      'background-color': ((planTopData['tableMouseMove'] || planBottomData['vehicleItemMouseMove']) ? '#0004' : '') }"></div>
      
    <!-- ToolTip (For dragging) HTML -->
    <div class="tooltipMove" ref="tooltipMove" v-if="planTopData['tableMouseMove']" :style="{
      'top': '0px',
      'left': '0px'}">
      <div class="row" v-for="(d, i) in planTopData['tableSelected']" :key="'data' + i">&#9642; {{d['ConsignmentNo']}}</div>
      <div class="details">{{planTopData['tableSelected']['length']}} {{planTopData['tableSelected']['length'] == 1 ? 'item' : 'items'}} selected</div>
    </div>
    <div class="tooltipMove" ref="tooltipMove2" v-if="planBottomData['vehicleItemMouseMove']" :style="{
      'top': '0px',
      'left': '0px'}">
      <div class="row">&#9642; {{planBottomData['vehicleItemSel']['JobNo']}}</div>
    </div>

    <!-- Top Half HTML -->
    <div class="planTop" :style="{
      'bottom': ((resizeData['posY'] * 100) + '%'),
      'user-select': (resizeData['mouseDown'] ? 'none': ''),
      'pointer-events': (resizeData['mouseDown'] ? 'none': '')}">
      <div class="planDragCover" :style="{
        'pointer-events': ((planTopData['tableMouseMove'] || planBottomData['vehicleItemMouseMove']) ? '' : 'none'),
        'background-color': ((planTopData['tableMouseMove'] || planBottomData['vehicleItemMouseMove']) ? '#0004' : '') }"></div>

      <div class="planTopFilter">
        <div class="planLoader" v-if="planTopData['listLoadText']">
          <div class="msgBox">{{planTopData['listLoadText']}}</div>
        </div>
        <div class="planTopFunctions">
          <div class="functions">
            <button @click="filterBtn('resetTable', '')">Reset</button>
            <!-- <button>Save Watch List</button> -->
            <button @click="filterBtn('refreshFilter', 'norefresh')">Refresh</button>
            <!-- <button @click="filterBtn('refreshFilter', '')" :disabled="!planTopData['filterData']['baseSel']">Refresh</button> -->
          </div>
          <Dropdown placeholder="Base" :items="planTopData['filterData']['baseItems']" itemKey="base" :isRequired="true" :errorMessage="planTopData['filterData']['errorMsg']['base']" :selectedObject.sync="planTopData['filterData']['baseSel']"/>
          <Dropdown placeholder="Team" :items="planTopData['filterData']['teamItems']" itemKey="Team" :selectedObject.sync="planTopData['filterData']['teamSel']"/>
          <Dropdown placeholder="Job Type" :items="planTopData['filterData']['jobItems']" itemKey="Description" :selectedObject.sync="planTopData['filterData']['jobSel']"/>
          
          <div class="row" :style="{ 'padding': '0 6px' }">
            <DateTimePicker placeholder="Required" :showTime="false" :value.sync="planTopData['filterData']['jobStartDate']"/>
            <DateTimePicker placeholder="To" :showTime="false" :value.sync="planTopData['filterData']['jobEndDate']"/>
          </div>

          <div class="row" :style="{ 'padding': '0 0 0 0' }">
            <Dropdown class="rowDropdown" placeholder="Leg" :items="planTopData['filterData']['legItems']" itemKey="leg" :selectedObject.sync="planTopData['filterData']['legSel']"/>
            <Dropdown class="rowDropdown" placeholder="Confirm?" :items="planTopData['filterData']['confirmItems']" itemKey="confirm" :isRequired="true" :errorMessage="planTopData['filterData']['errorMsg']['confirm']" :selectedObject.sync="planTopData['filterData']['confirmSel']"/>
          </div>
          
          <div class="row" :style="{ 'width': 'calc(100% - 20px)', 'padding': '0 5px' }">
            <div class="row">
              <Input class="input" placeholder="Weight (KG)" textType="number" :inputValue.sync="planTopData['filterData']['weight']" validator="positiveDecimal,10,4" />
              <button @click="filterBtn('weightCompare')">
                {{(planTopData['filterData']['weightCompare'] == 0) ? '&#62;=' : ((planTopData['filterData']['weightCompare'] == 1) ? '&#60;=' : '=')}}
              </button>
            </div>

            <div class="row">
              <Input class="input" placeholder="M3" textType="number" :inputValue.sync="planTopData['filterData']['m3']" validator="positiveDecimal,10,4" />
              <button @click="filterBtn('m3Compare')">
                {{(planTopData['filterData']['m3Compare'] == 0) ? '&#62;=' : ((planTopData['filterData']['m3Compare'] == 1) ? '&#60;=' : '=')}}
              </button>
            </div>
          </div>
          
          <!-- <Dropdown placeholder="View Option" :items="planTopData['filterData']['viewItems']" itemKey="option" :selectedObject.sync="planTopData['filterData']['viewSel']"/> -->
          
          <CheckBox class="tableCheckbox" title="Assign by Job" :isChecked.sync="planTopData['tableAssignByJob']"/>
        </div>

        <div class="planTopFilterList">
          <div class="planTopFilterMain" v-for="(f, i) in planTopData['listItems']" :key="'dropper' + i">
            <div class="header" @click="filterBtn('show', f, $event)">
              <div class="title">{{f['title']}}</div>
              <div class="functions">{{f['show'] ? '&#9650;' : '&#9660;'}}</div>
            </div>
            <div class='content' v-if="f['show']">
              <div class="filterMain" v-for="(f2, i2) in f['filterItems']" :key="'filter' + i2" 
                @click="filterBtn('fillTable', { item: f2, title: f['title'] })" :style="{ backgroundColor: `${f['title']}_${f2['Id']}` == selectedFilters ? 'gray' : '',
                color: `${f['title']}_${f2['Id']}` == selectedFilters ? 'white' : '' }">

                <div class="filterItem">{{f2['FilterItem']}}</div>
                <div class="filterOption">{{f2['FilterOption']}}</div>
                <div class="filterCount">{{f2['Consignment'] ? (f2['Consignment']['length'] - (f['filterAssigned'][i2] ? f['filterAssigned'][i2] : 0)).toFixed(0) : '0'}}/{{f2['Consignment'] ? f2['Consignment']['length'] : '0'}}</div>
              </div>
            </div>
          </div>

          <div class="planTopFilterMsg" v-if="planTopData['listItems']['length'] <= 0">{{planTopData['listMsg']}}</div>
        </div>
      </div>

      <div class="planTopTableMain">
        <div class="planTopDetailsMain">
          <div class="planTopDetails" v-for="(d, i) in planTopData['tableTopDetails']" :key="'details' + i" :style="{
            'border-right': (((i + 1) == planTopData['tableTopDetails']['length']) ? '' : 'solid 1px lightgray')}">
            <div class="planTopDetailsRow" v-for="(r, i) in d" :key="'rowD' + i">
              <div class="title">{{r['title']}}</div>
              <div class="value">{{r['value']}}</div>
            </div>
          </div>
        </div>

        <div class="planTopTable">
          <div class="tableTopFunctions" v-if="false">
            <button v-for="(f, i) in planTopData['tableTopFunctions']" :key="'tableTopBtn' + i" :style="{
              'color': f['FColor'],
              'background-color': f['BGColor'] }">
              {{f['title']}}
            </button>
          </div>

          <div class="tableMain" @mousedown="tableMouseDown('', $event)" @mouseup="tableMouseUp">
            <div class="tableFunctions">
              <button id="selectAllBtn" @click="tableBtn('selectAll', '')" v-if="planTopData['tableData']['length'] > 0">{{(planTopData['tableSelected']['length'] >= planTopData['tableData']['length']) ? 'Deselect' : 'Select'}} All</button>
            </div>
            <TableBox v-if="showPlanTopData" title="Data" class="table" ref="tableMain" :dataType="this.topTableDataTypes" :style="{ 'pointer-events': (planTopData['tableMouseMove'] ? 'none' : '') }"
              :tableData="planTopData['tableData']" :selectedRow.sync="planTopData['tableSelected']" :hideColumns="['strFilterOption', 'strFilterItem']"
              :maxSelection="-1" @rowSelected="rowSelected" />
            <!-- <Tabulator class="table" ref="tableMain" :style="{ 'pointer-events': (planTopData['tableMouseMove'] ? 'none' : '') }"
              :tableData.sync="planTopData['tableData']" :selectedRow.sync="planTopData['tableSelected']" :hideColumns="['strFilterOption', 'strFilterItem']"
                :maxSelection="-1"/> -->
          </div>
        </div>
      </div>
    </div>

    <SimplePopup v-show="journeyView" :show.sync="journeyView" :title="'Your Journey on Maps'" @close="closeClicked">
      <div class="mapFunctionDisplay">
        <div class="listView wrapper">
          <Tab class="journeyTabs" :tabs="journeyTabItems" :tabIndex="journeyTabIndex" @update:tabIndex="journeyTabIndexUpdate"> 
            <div slot="Original Route_details" class="tab-details">
              <div><strong>Duration:</strong> {{ this.totalHours }} hours {{ this.totalMinutes }} minutes</div>
              <div><strong>Distance:</strong> {{ this.totalDistance }} km</div>
            </div>
            <div slot="Original Route" class="originalRouteTab" style="height: 100%">
              <div class="dropOffDurationDiv"><strong>Load/Unload Time: </strong><input type="text" class="dropOffDurationInput" v-model.lazy="dropOffDuration" @change="dropOffTimeChange"> minutes per drop off</div>
              <div class="destinationList" v-for="(location, index) in locations" :key="location.id">
                <div class="indexDiv">{{ String.fromCharCode(65 + index) }}</div>
                <div class="locationInputComp" v-if="locations.indexOf(location) === 0">{{ location.name }}</div> 
                <div class="locationInputComp" v-else-if="locations.indexOf(location) === Object.keys(locations).length - 1">{{ location.name }}</div> 
                <div class="locationInputComp" v-else>{{ location.name }}</div>  
                <div class="timeDisplayDiv" v-if="estimatedTime.length > 0">{{ estimatedTime[index].toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'}) }}</div>
                <div class="shareButtonDiv" v-if="estimatedTime.length > 0"><span class="shareButton" @click="sharePopup(index)"><img src="https://img.icons8.com/material-outlined/18/000000/share.png"></span></div>
              </div>
            </div>
            <div slot="Optimized Route_details" class="tab-details">
              <div><strong>Duration:</strong> {{ this.totalHours2 }} hours {{ this.totalMinutes2 }} minutes</div>
              <div><strong>Distance:</strong> {{ this.totalDistance2 }} km</div>
            </div>
            <div slot="Optimized Route" class="optimizedRouteTab">
              <div class="departureDiv">
                <div class="clockIconDiv">
                  <img src="https://img.icons8.com/material-outlined/50/000000/clock--v1.png"/>
                </div>
                <div class="routeTypeList">
                  <select class="departureType" v-model="selectedDepartureType" @change="timeUpdate">
                    <option value="leaveNow">Leave Now</option>
                    <option value="departAt">Depart At</option>
                    <option value="arriveBy">Arrive By</option>
                  </select>
                </div>
                <div class="timeInputDisplay">
                  <input v-if="selectedDepartureType !== 'leaveNow'" type="time" class="selectTime" v-model="currentTimeDisplay" @change="timeUpdate">
                </div>
              </div>
              <div class="destinationContainer">
                <div class="destinationList" v-for="(location, index) in optimizedJourney" :key="location.id">
                  <div class="indexDiv">{{ String.fromCharCode(65 + index) }}</div>
                  <div class="locationInputComp" v-if="locations.indexOf(location) === 0">{{ location.name }}</div> 
                  <div class="locationInputComp" v-else-if="locations.indexOf(location) === Object.keys(locations).length - 1">{{ location.name }}</div> 
                  <div class="locationInputComp" v-else>{{ location.name }}</div>  
                  <div class="timeDisplayDiv" v-if="estimatedTime.length > 0">{{ estimatedTime[index].toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'}) }}</div>
                  <div class="shareButtonDiv" v-if="estimatedTime.length > 0"><span class="shareButton" @click="sharePopup(index)"><img src="https://img.icons8.com/material-outlined/18/000000/share.png"></span></div>
                </div>
              </div>
              <button @click="resetSequence">Use Optimized Route</button>
            </div>
          </Tab>
        </div>
        <div class="mpaView wrapper">
          <GMapV2 class="gMapMain" ref="gmap" @directions="getDirections" @optimizedDirections="getOptimizedDirections" :mOptions="mOptions" :mMetric="selectedMetric"/>
        </div>
      </div>
    </SimplePopup>

    <div v-if="shareETAPopup" class="share-selection">
      <div class="share-popup-title" style="padding:10px;">
        <img src="https://img.icons8.com/dusk/90/000000/share-2.png"/><br />
        Share
      </div>
      <div class="share-popup-container">
        <button @click="emailShare" style="background:#505050;color:#FFFFFF;margin:5px;width:115px;"><img src="https://img.icons8.com/ios-glyphs/20/ffffff/filled-message.png"/> Email</button>
        <button @click="whatsappShare" style="background:#25D366;color:#FFFFFF;margin:5px;width:115px;"><img src="https://img.icons8.com/color/21/000000/whatsapp.png"/> WhatsApp</button>
        <button @click="telegramShare" style="background:#0088cc;color:#FFFFFF;margin:5px;width:115px;"><img src="https://img.icons8.com/color/20/000000/telegram-app.png"/> Telegram</button>
      </div>
      <div class="share-cancel"> 
        <button @click="sharePopup(null)" style="margin:5px;">Cancel</button>
      </div>
    </div>

    <!-- Resizer HTML -->
    <div class="planResize" ref="planResize" :style="{
      'top': (((1 - resizeData['posY']) * 100) + '%'),
      'pointer-events': (resizeData['mouseDown'] ? 'none': '')}"
      @mousedown="resizeMouseDown('' , $event)"></div>

    <!-- Bottom Half HTML -->
    <div class="planBottom" :style="{
      'top': 'calc(' + (((1 - resizeData['posY']) * 100) + '%') + ' + 12px',
      'user-select': (resizeData['mouseDown'] ? 'none': ''),
      'pointer-events': (resizeData['mouseDown'] ? 'none': '')}">
      <div class="planDragCover" :style="{
        'pointer-events': ((planTopData['tableMouseMove'] || planBottomData['vehicleItemMouseMove']) ? '' : 'none'),
        'background-color': ((planTopData['tableMouseMove'] || planBottomData['vehicleItemMouseMove']) ? '#0004' : '') }"></div>

      <div class="planBottomFilter">
        <div class="planLoader" v-if="planBottomData['listLoadText']">
          <div class="msgBox">{{planBottomData['listLoadText']}}</div>
        </div>
        <div class="planBottomFunctions">
          <div class="functions">
            <button @click="filterBtn('resetVehicle', '')">Reset</button>
            <button @click="filterBtn('refreshVehicle', 'norefresh')">Refresh</button>
            <!-- <button @click="filterBtn('refreshVehicle', '')" :disabled="!planTopData['filterData']['baseSel']">Refresh</button> -->
          </div>
          <div class="row">
            <DateTimePicker placeholder="Journey Date" :showTime="false" :value.sync="planBottomData['filterData']['vehStartDate']"/>
            <!-- <DateTimePicker placeholder="To" :showTime="false" :value.sync="planBottomData['filterData']['vehEndDate']"/> -->
          </div>
        </div>
        <div class="planBottomFilterList">
          <div class="planBottomFilterMain" v-for="(f, i) in planBottomData['listItems']" :key="'dropper' + i">
            <div class="header" @click="filterBtn('show', f, $event)">
              <div class="vehicleCheck" id="vehicleCheck">{{(f['vehicleItems'].filter((v, i) => { return v['selected']; })['length'] == f['vehicleItems']['length']) ? '&#10004;' : ''}}</div>
              <div class="title">{{f['title']}}</div>
              <div class="vehicleCount">{{f['vehicleItems']['length']}}</div>
              <div class="functions">{{f['show'] ? '&#9650;' : '&#9660;'}}</div>
            </div>
            <div class='content' v-if="f['show']">
              <div class="vehicleMain" v-for="(f2, i2) in f['vehicleItems']" :key="'vehicle' + i2"
                @click="filterBtn('fillVehicleTable', f2)">
                <div class="vehicleCheck">{{f2['selected'] ? '&#10004;' : ''}}</div>
                <div class="vehicleDesc">{{f2['Lorry_No']}} {{f2['VehicleCode'] ? ('(' + (f2['VehicleCode'].trim() ? f2['VehicleCode'].trim() : '') + ')') : ''}}</div>
                <div class="vehicleType">{{f2['Type']}}</div>
                <div class="vehicleCount">{{Object.keys(f2['vehicleItems'])['length']}}</div>
                <!-- <div class="filterCount">{{f2['Consignment'] ? (f2['Consignment']['length'] - (f['filterAssigned'][i2] ? f['filterAssigned'][i2] : 0)).toFixed(0) : '0'}}/{{f2['Consignment'] ? f2['Consignment']['length'] : '0'}}</div> -->
              </div>
            </div>
          </div>
          
          <div class="planBottomFilterMsg" v-if="planBottomData['listItems']['length'] <= 0">{{planBottomData['listMsg']}}</div>
        </div>
      </div>

      <div class="planBottomVehicleListMain">
        <div class="planBottomVehicleFunctions">
          <div class="planBottomVehicleLegend">
            <div class="item">
              <div class="color" :style="{ 'background-color': '#6ee675'}"></div>
              <div class="title">Assigned</div>
            </div>
            <div class="item">
              <div class="color" :style="{ 'background-color': '#ff8f8f'}"></div>
              <div class="title">Cancel</div>
            </div>
            <div class="item">
              <div class="color" :style="{ 'background-color': '#ffffff'}"></div>
              <div class="title">Unsaved</div>
            </div>
          </div>

          <div class="planBottomVehicleButtonList">
            <!-- <button @click="tableBtn('test', '')">Test</button> -->
            <button @click="tableBtn('vehicleSelectOpen', '')">Print</button>
            <button :disabled="(planBottomData['vehicleItemList']['length'] <= 0) && !vehicleListSaveAll()"
               @click="tableBtn('vehicleSaveAll', { 'status': 'check', 'errMsg': '' })">Save All Edited </button>
          </div>
        </div>
        
        <div class="planBottomVehicleList" :style="{ 
          'border': ((planBottomData['vehicleMouseEnter'] && !planBottomData['vehicleListSel'] && planBottomData['vehicleList']['length'] <= 0) ? 'solid 1px red' : '') }"
          
          @mouseleave="vehicleMouseLeave('', $event)"
          @mouseenter="vehicleMouseEnter('', $event)">
          
          <div class="vehicleItemMain" :id="'vehicle' + i" v-for="(v, i) in planBottomData['vehicleList']" :key="'vehicle' + i" :style="{
            'background-color': (planBottomData['vehicleListSel'] ? (((planBottomData['vehicleListSel']['vehicleDetails']['vehNo'] == v['vehicleDetails']['vehNo']) &&
              (planBottomData['vehicleListSel']['vehicleDetails']['vehCode'] == v['vehicleDetails']['vehCode']) &&
              (planBottomData['vehicleListSel']['vehicleDetails']['vehType'] == v['vehicleDetails']['vehType']) && (planBottomData['vehicleMouseEnter'] || planBottomData['vehicleItemMouseMove'])) ? '#c6e6c1' : '') : '')}"

            @mouseleave="vehicleItemMouseLeave('', $event)"
            @mouseenter="vehicleItemMouseEnter(('vehicle' + i), v)">
            <div class="vehicleDetails">
              <div class="item">
                <img class="icon" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-in-transit-64.png"/>
                <div class="value">{{getVehicleInfo(v)}}</div>
              </div>
              <div class="item">
                <img class="icon" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-customer-64.png"/>
                <!-- <div class="value">{{getDriverInfo(v)}}</div> -->
                <div class="value">
                  <Dropdown placeholder="Driver" :items="planBottomData['filterData']['driverItems']" itemKey="desc" :isRequired="true" 
                    :errorMessage.sync="v['driverDetails']['drvErrorMsg']"
                    :selectedObject.sync="v['driverDetails']['drvSel']"/>
                </div>
              </div>
              <div class="item" style="height:65px;">
                <img class="icon" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-customerblue-64.png"/>
                <div class="value">
                  <Filters :title="`Attendant(${v['attendantDetails'].length})`" :tableData="planBottomData['filterData']['attendantItems']" itemKey="desc" :maxSelection="2" 
                    :isFullScreen="false" :selectedObject.sync="v['attendantDetails']" />
                </div>
              </div>
              <div class="item">
                <img class="icon" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-todo-list-64.png"/>
                <div class="value">{{getJobCount(v['vehicleItems'])}}</div>
              </div>
            </div>

            <div class="vehicleItemList" id="vehicleItemList">
              <div class="vehicleJourneyList" :id="j" v-for="(j, jInd) in Object.keys(v['vehicleItems'])" :key="'journey' + jInd"
                :style="{'background-color': (planBottomData['vehicleListSel'] ? (((planBottomData['vehicleListSel']['vehicleDetails']['vehNo'] == v['vehicleDetails']['vehNo']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehCode'] == v['vehicleDetails']['vehCode']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehType'] == v['vehicleDetails']['vehType'])) &&
                  ((((planBottomData['vehicleJourneySel'] ? planBottomData['vehicleJourneySel']['journey'] : '') == j) && (planBottomData['vehicleMouseEnter'] || planBottomData['vehicleItemMouseMove'])) ? 'lightblue' : '')) : ''),
                  'border': (planBottomData['vehicleListSel'] ? (((planBottomData['vehicleListSel']['vehicleDetails']['vehNo'] == v['vehicleDetails']['vehNo']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehCode'] == v['vehicleDetails']['vehCode']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehType'] == v['vehicleDetails']['vehType'])) &&
                  ((((planBottomData['vehicleJourneySel'] ? planBottomData['vehicleJourneySel']['journey'] : '') == j) && (planBottomData['vehicleMouseEnter'] || planBottomData['vehicleItemMouseMove'])) ? 'solid 1px gray' : '')) : '')}"

                @mouseleave="vehicleJourneyMouseLeave('', $event)"
                @mouseover="vehicleJourneyMouseOver(j, v['vehicleItems'][j], $event)">
                <div class='journeyTitle'>{{j ? j.trim() : ''}}</div>  
                <div class="vehicleDetailsButton">
                  <button class="mapButton" @click="processJourney(v['vehicleItems'][j], j)"><img class="mapButtonImage" src='https://dsmapi.logistics.systems/dsm6gicons/Map.png'>Show Journey</button>
                </div>
                <div class="vehicleItem" id="vehicleItem" v-for="(vI, viInd) in v['vehicleItems'][j]" :key="'item' + viInd" :style="{
                  'margin': ((viInd + 1) < v['vehicleItems']['length']) ? '0 5px 0 0' : '',
                  'border': (vI['dragging'] ? 'solid 1px gray' : ''),
                  'opacity': ((!vI['dragging'] && planBottomData['vehicleItemMouseMove']) ? '0.7' : ''),
                  'pointer-events': ((planBottomData['vehicleItemMouseMove']) ? 'none' : '')}"

                  @mousedown="vehicleItemMouseDown('',v, vI, $event)">
                  <div class="details">
                    <div class="row" style="font-weight: bold;">{{vI['JobNo'] ? vI['JobNo'].trim() : ''}}{{vI['Cu_Number'] ? (' (' + vI['Cu_Number'].trim() + ')') : ''}}</div>
                    <div class="row">{{vI['Pickup'] ? vI['Pickup'] : ''}}{{vI['DropOff'] ? ' - ' +vI['DropOff'] : ''}}</div>
                    <div class="row">{{vI['Qty'] ? 'Qty: ' + vI['Qty'] : ''}}</div>
                    <div class="row">{{vI['Weight'] ? ' Weight: ' + vI['Weight'] : ''}}</div>
                    <div class="row">{{vI['M3'] ? ' M3: ' + vI['M3'] : ''}}</div>
                    <!-- <div class="row">{{vI['Qty'] ? 'Qty:' + vI['Qty'] : ''}}{{vI['Weight'] ? ' Weight:' + vI['Weight'] : ''}}{{vI['M3'] ? ' M3:' + vI['M3'] : ''}}</div> -->
                    <div class="list">
                      <div class="row" id="vehicleItemConsignment" v-for="(vJ, i2) in vI['Consignments']" :key="'consignment' + viInd + ',' + i2" :style="{
                        'background-color': (vJ['existing'] ? (vJ['delete'] ? '#ff8f8f' : '#6ee675') : '')}"

                        @mousedown="vehicleItemMouseDown('',v, vI, $event)">
                        <div class="text">{{vJ['ConsignmentNo'] ? vJ['ConsignmentNo'] : ''}}</div> 
                        <div class="remove" @click="tableBtn('removeSingle', { 'vehicle': v, 'job': vI, 'items': vJ })">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div class="functions">
                    <div class="remove" @click="tableBtn('remove', { 'vehicle': v, 'job': vI, 'cmd': '' })">&#10005;</div>
                    <div class="seqNo">{{vI['seqNo'] ? vI['seqNo'] : ''}}</div>
                    <Tooltip @click.native="tableBtn('showDetails', { 'vehicle': v, 'job': vI, rowIndex: i })" :showIndicator="false" position="top" :minWidth="50" :yOffset="-2" tooltipText="Job Details" :style="{'pointer-events': 'all'}"></Tooltip>
                  </div>
                </div>
              </div>
              <div class="vehicleJourneyList" :style="{'min-width': '60px',
                'background-color': (planBottomData['vehicleListSel'] ? (((planBottomData['vehicleListSel']['vehicleDetails']['vehNo'] == v['vehicleDetails']['vehNo']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehCode'] == v['vehicleDetails']['vehCode']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehType'] == v['vehicleDetails']['vehType'])) &&
                  ((((planBottomData['vehicleJourneySel'] ? planBottomData['vehicleJourneySel']['journey'] : '') == 'new') && (planBottomData['vehicleMouseEnter'] || planBottomData['vehicleItemMouseMove'])) ? 'lightblue' : '')) : ''),
                'border': (planBottomData['vehicleListSel'] ? (((planBottomData['vehicleListSel']['vehicleDetails']['vehNo'] == v['vehicleDetails']['vehNo']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehCode'] == v['vehicleDetails']['vehCode']) &&
                  (planBottomData['vehicleListSel']['vehicleDetails']['vehType'] == v['vehicleDetails']['vehType'])) &&
                  ((((planBottomData['vehicleJourneySel'] ? planBottomData['vehicleJourneySel']['journey'] : '') == 'new') && (planBottomData['vehicleMouseEnter'] || planBottomData['vehicleItemMouseMove'])) ? 'solid 1px gray' : '')) : '')}"
                
                @mouseleave="vehicleJourneyMouseLeave('', $event)"
                @mouseover="vehicleJourneyMouseOver('new', [], $event)">
                <div class='journeyTitle' :style="{'font-weight': 'normal'}">Add Journey</div>
              </div>
            </div>

            <!-- <div class="vehicleItemFunctions">
              <button @click="tableBtn('vehicleSave', v)" :disabled="!vehicleListSave(v)">Save</button>
            </div> -->
          </div>

          <div class="vehicleItemEmpty" v-if="planBottomData['vehicleList']['length'] <= 0">No Vehicles Found</div>
        </div>
      </div>

    </div>

    <div class="vehicleItemPopupMain" v-if="vehicleDetailsShow">
      <div class="vehicleItemPopup">
        <div class="header">
          <div class="title">Job Details {{ vehicleDetailsListSel ? (vehicleDetailsListSel['JobNo'] ? ('[' + vehicleDetailsListSel['JobNo'].trim() + ']') : '') : '' }}</div>
          <div class="remove" @click="tableBtn('hideDetails', '')">&#10005;</div>
        </div>
        <div class="body">
          <div class="row">
            <div class="title">Vehicle No</div>
            <div class="value">{{ vehicleDetailsSel['vehicleDetails'] ? (vehicleDetailsSel['vehicleDetails']['vehNo'] ? vehicleDetailsSel['vehicleDetails']['vehNo'].trim() : '') : '' }}</div>
          </div>
          <div class="row">
            <div class="title">Vehicle Code</div>
            <div class="value">{{ vehicleDetailsSel['vehicleDetails'] ? (vehicleDetailsSel['vehicleDetails']['vehCode'] ? vehicleDetailsSel['vehicleDetails']['vehCode'].trim() : '') : '' }}</div>
          </div>
          <div class="row">
            <div class="title">Vehicle Type</div>
            <div class="value">{{ vehicleDetailsSel['vehicleDetails'] ? (vehicleDetailsSel['vehicleDetails']['vehType'] ? vehicleDetailsSel['vehicleDetails']['vehType'].trim() : '') : '' }}</div>
          </div>

          <!-- <div class="row">
            <div class="title">Driver Name</div>
            <div class="value">{{ vehicleDetailsSel['driverDetails'] ? (vehicleDetailsSel['driverDetails']['drvName'] ? vehicleDetailsSel['driverDetails']['drvName'].trim() : '') : '' }}</div>
          </div>
          <div class="row">
            <div class="title">Driver Status</div>
            <div class="value">{{ vehicleDetailsSel['driverDetails'] ? (vehicleDetailsSel['driverDetails']['drvStatus'] ? vehicleDetailsSel['driverDetails']['drvStatus'].trim() : '') : '' }}</div>
          </div> -->
          
          <div class="row">
            <div class="title">Job No</div>
            <div class="value">{{ vehicleDetailsListSel ? (vehicleDetailsListSel['JobNo'] ? vehicleDetailsListSel['JobNo'].trim() : '') : '' }}</div>
          </div>
          <div class="row">
            <div class="title">Pickup</div>
            <div class="value">{{ vehicleDetailsListSel ? (vehicleDetailsListSel['Pickup'] ? vehicleDetailsListSel['Pickup'].trim() : '') : '' }}</div>
          </div>
          <div class="row">
            <div class="title">Dropoff</div>
            <div class="value">{{ vehicleDetailsListSel ? (vehicleDetailsListSel['DropOff'] ? vehicleDetailsListSel['DropOff'].trim() : '') : '' }}</div>
          </div>
          <div class="row">
            <div class="title">Total Quantity</div>
            <div class="value">{{ vehicleDetailsListSel ? (vehicleDetailsListSel['Qty'] ? vehicleDetailsListSel['Qty'] : '0') : '0' }}</div>
          </div>
          <div class="row">
            <div class="title">Total Weight</div>
            <div class="value">{{ vehicleDetailsListSel ? (vehicleDetailsListSel['Weight'] ? vehicleDetailsListSel['Weight'] : '0') : '0' }}</div>
          </div>
          <div class="row">
            <div class="title">Total M3</div>
            <div class="value">{{ vehicleDetailsListSel ? (vehicleDetailsListSel['M3'] ? vehicleDetailsListSel['M3'] : '0') : '0' }}</div>
          </div>

          <div class="consignment" v-for="(c, i) in vehicleDetailsListSel['Consignments']" :key="'consignmentD' + i">
            <div class="header">{{ c['ConsignmentNo'] ? c['ConsignmentNo'].trim() : '' }}</div>
            <div class="row">
              <div class="title">Required Date</div>
              <div class="value">{{ c['RequiredDate'] ? formatDatetoString(c['RequiredDate']) : '' }}</div>
            </div>
            <div class="row">
              <div class="title">Due Date</div>
              <div class="value">{{ c['DueDate'] ? formatDatetoString(c['DueDate']) : '' }}</div>
            </div>
            <div class="row">
              <div class="title">Leg No</div>
              <div class="value">{{ c['LegNo'] ? c['LegNo'].trim() : '' }}</div>
            </div>
            <div class="row">
              <div class="title">DropOff</div>
              <div class="value">{{ c['DropOff_Name'] ? c['DropOff_Name'].trim() : '' }}</div>
            </div>
            <div class="row">
              <div class="title">Final DropOff</div>
              <div class="value">{{ c['FinalDropOff_Name'] ? c['FinalDropOff_Name'].trim() : '' }}</div>
            </div>
            <div class="row" style="justify-content: unset; margin-top: 7px">
              <div class="title">Quantity</div>
              <div class="value" style="max-width: 30px">{{ c['Total'] ? c['Total'] : (c['BalQty'] ? c['BalQty'] : '0') }}</div>
              <input v-if="c['updating']" type="number" v-model="c['newQty']"
                style="font-size: 10px; padding: 0; border: none !important; max-width: 50px; height: 12px; transform: translateY(2px)" min="0" disabled />
            </div>
            <div class="row" style="justify-content: unset; margin-top: 7px">
              <div class="title">Weight / TB</div>
              <div class="value" style="max-width: 30px">{{ c['TB'] ? c['TB'] : (c['BalWeight'] ? c['BalWeight'] : '0') }}</div>
              <input v-if="c['updating']" type="number" v-model="c['newWeight']"
                style="font-size: 10px; padding: 0; border: none; border-bottom: 1px solid gray; max-width: 50px; height: 12px; transform: translateY(2px)" min="0"
                @change="newValueChanged(c)"/>
            </div>
            <div class="row" style="justify-content: unset; margin-top: 7px; margin-bottom: 3px">
              <div class="title">M3 / CTN</div>
              <div class="value" style="max-width: 30px">{{ c['CTN'] ? c['CTN'] : (c['BalM3'] ? c['BalM3'] : '0') }}</div>
              <input v-if="c['updating']" type="number" v-model="c['newM3']"
                style="font-size: 10px; padding: 0; border: none; border-bottom: 1px solid gray; max-width: 50px; height: 12px; transform: translateY(2px)" min="0"
                @change="newValueChanged(c)"/>
            </div>
            <div class="update-button">
              <button class="save" v-if="c['updating']" @click="updateKgM3QtySave(c, i)">
                <img src="https://dsmlib.logistics.systems/Icons/Save.png">
                Save
              </button>
              <button class="cancel" v-if="c['TMSJINo']" @click="updateKgM3QtyClicked(c, c['updating'] ? 'Cancel' : 'Update')">
                <img v-if="c['updating']" src="https://dsmlib.logistics.systems/Icons/Cancel.png">
                {{ c['updating'] ? 'Cancel' : 'Update' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Save All prompt (when there is edited data) -->
    <div class="savePopupMain" v-if="saveShow">
      <div class="savePopup">
        <div class="header">Unsaved Changes</div>
        <div class="body">
          <!-- There were {{planBottomData['vehicleItemList']['length']}} items that were unsaved.<br> -->
          There {{planBottomData['vehicleItemList']['length'] >= 2 ? 'are' : 'is'}} {{planBottomData['vehicleItemList']['length']}} unsaved {{planBottomData['vehicleItemList']['length'] >= 2 ? 'items' : 'item'}}.<br>
          You may Discard or Save Changes, or Cancel to continue editing.
        </div>
        <div class="functions">
          <button @click="saveBtn('cancel', '')">Cancel</button>
          <button @click="saveBtn('discard', '')">Discard Changes</button>
          <button @click="saveBtn('save', '')">Save Changes</button>
        </div>
      </div>
    </div>

    <!-- Discard prompt (when a vehicle is unchecked from list) -->
    <div class="savePopupMain" v-if="discardShow">
      <div class="savePopup">
        <div class="header">Unsaved Changes</div>
        <div class="body">
          <!-- There were {{planBottomData['vehicleItemList']['length']}} items that were unsaved.<br> -->
          {{discardData ? (discardData['Lorry_No'] ? discardData['Lorry_No'].trim() : '') : ''}}{{discardData ? (discardData['VehicleCode'] ? (' (' + discardData['VehicleCode'].trim() + ')') : '') : ''}}{{discardData ? (discardData['Type'] ? (' (' + discardData['Type'].trim() + ')') : '') : ''}} has unsaved changes, deselecting this will discard any unsaved data.<br>
          You may Discard Changes or Cancel to continue editing.
        </div>
        <div class="functions">
          <button @click="tableBtn('discardCancel', '')">Cancel</button>
          <button @click="tableBtn('discardChanges', '')">Discard Changes</button>
        </div>
      </div>
    </div>

    <div class="printSelectPopUpMain" v-show="printSelectShow">
      <div class="printSelectPopUp">
        <div class="header">Please select which Journey to Print</div>
        <Dropdown placeholder="Print Format" :items="printFormatList" itemKey="value" :selectedObject.sync="selectedPrintFormat"
          :errorMessage.sync="selectedPrintFormatError" />
        <div class="body">
          <div class="printSelectMsg" v-if="printSelectList['length'] <= 0">{{printSelectMsg}}</div>
          <div class="printSelectItem" v-for="(j, i) in printSelectList" :key="'jino' + i"
            @click="tableBtn('vehiclePrint', j)">
            <div class="header">Journey # ({{j['JHTMSJINO']}})</div> 
            <div class="details">
              <div class="item">
                <img class="icon" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-in-transit-64.png"/>
                <div class="value">{{j['JHVehicleCode'] ? j['JHVehicleCode'] : ''}}</div>
                <div class="value2">{{j['Lorry_No'] ? j['Lorry_No'] : ''}}</div>
              </div>
              <div class="item">
                <img class="icon" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-customer-64.png"/>
                <div class="value">{{j['JHDriver'] ? j['JHDriver'] : ''}}</div>
                <div class="value2">{{j['DriverName'] ? j['DriverName'] : ''}}</div>
              </div>
            </div> 
          </div>
        </div>
        <div class="functions">
          <button @click="tableBtn('vehicleSelectCancel', '')">Cancel</button>
        </div>
      </div>
    </div>

    <div class="designerPopUpMain" v-show="printShow">
      <Designer class="designerPopUp" :data.sync="printData" :quickPrint="true" form="TSManifest.json" @cancel="printShow = false"/>
    </div>

    <div class="designerv2-popup" v-if="showDesignerV2">
      <DesignerV2 :show.sync="showDesignerV2" :viewMode="true" reportFolder="ROTForm" :reportFile="designerV2ReportFile"
        :reportData="designerV2Data" :showBackground.sync="designerV2ShowBackground" />
    </div>

		<Loader :isVisible="loadShow" :loadingText="loadText" />
  </div>
</template>

<script>
  import CheckBox from '@/components/CheckBox.vue';
  import Tabulator from '@/components/Tabulator.vue';
  import Designer from '@/components/reportDesigner/Designer.vue';
  import GMapV2 from '@/components/GoogleMapV2.vue';
  import SimplePopup from '@/components/formVerification/SimplePopup.vue';
  import Tab from "@/components/Tab.vue";

  /* eslint-disable */

  export default {
    name: 'planassign',
    components: {
      CheckBox, Tabulator, Designer, GMapV2, SimplePopup, Tab
    },
    props: {
      paMapShow: {
        type: Array, default: function() {
          return [{ value: 'Show Location', type: 'button', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Map.png', index: '0' }];
        }
      },
      mOptions: { type: Object, default: function () { return { clickable: true, draggable: false }; } },
     
    },
    data() {
      return {
        showPlanTopData: true,
        planTopData: {
          'filterData': {
            //-- Lists
            'baseItems': [],
            'teamItems': [],
            'jobItems': [],
            'legItems': [
              { 'leg': 1 },
              { 'leg': 2 },
              { 'leg': 3 },
            ],
            'confirmItems': [
              { 'confirm': 'Yes', 'value': 'Y' },
              { 'confirm': 'No', 'value': 'N' },
            ],
            'viewItems': [
              { 'option': 'By Job' },
              { 'option': 'By Consignment' },
            ],

            //-- Selected Items
            'baseSel': null,
            'teamSel': null,
            'jobSel': null,
            'legSel': null,
            'confirmSel': null,
            'viewSel': null,
            'listSel': null,

            //-- String Inputs
            'weight': '0',
            'weightCompare': 0,
            'm3': '0',
            'm3Compare': 0,

            //-- Date Inputs
            'jobStartDate': new Date,
            'jobEndDate': new Date,

            //-- Required Error Msgs
            'errorMsg': {
              'base': '',
              'confirm': '',
            },
          },
          'listItems': [
            // { 'title': 'Important Date', 'show': false },
            // { 'title': 'By Customer', 'show': false },
            // { 'title': 'Job Type', 'show': false },
            // { 'title': 'Pick-Up by Zone', 'show': false },
            // { 'title': 'Pick-Up by Area', 'show': false },
            // { 'title': 'Drop-Off by Zone', 'show': false },
            // { 'title': 'Drop-Off by Area', 'show': false },
            // { 'title': 'Route', 'show': false },
          ],
          'listMsg': 'Please set the options above and Refresh',
          'listLoadText': '',
          'tableTopDetails': [
            [
              { 'title': 'Base', 'value': '' },
              { 'title': 'Team', 'value': '' },
              { 'title': 'Start Date', 'value': '' },
              { 'title': 'End Date', 'value': '' },
            ],
            [
              { 'title': 'Job Type', 'value': '' },
              { 'title': 'Leg', 'value': '' },
              { 'title': 'Wt (KG)', 'value': '' },
              { 'title': 'M3', 'value': '' },
            ],
            [
              { 'title': 'Filter Option By', 'value': '' },
              { 'title': 'Confirm', 'value': '' },
              { 'title': 'Total Consignment #', 'value': '' },
              { 'title': 'Last Refresh', 'value': '' },
            ],
          ],
          'tableTopFunctions': [
            { 'title': '1 Day before Vessel ETA', 'BGColor': '#dd0000', 'FColor': '#ffffff' },
            { 'title': '10 Hour before Vessel Closing', 'BGColor': '#8888ff', 'FColor': '#ffffff' },
            { 'title': '1 Day before Demurrage Date', 'BGColor': '#ff0000', 'FColor': '#ffffff' },
            { 'title': '1 Day before Cust Required Data', 'BGColor': '#7017ff', 'FColor': '#ffffff' },
          ],

          'tableAssignByJob': true,

          'tableMouseDown': false,
          'tableMouseMove': false,

          'tableData': [],
          'tableSelected': [],
          'tableLastSelected': [],
        },

        planBottomData: {
          'filterData': {
            'driverItems': [],
            'attendantItems': [],

            //-- Date Inputs
            'vehStartDate': new Date,
            'vehEndDate': new Date,
          },
          'listItems': [
            // { 'title': 'VEHICLE WITHOUT JOBS', 'show': false },
            // { 'title': 'VEHICLE WITH JOBS', 'show': false },
            // { 'title': 'VEHICLE AT WORKSHOP', 'show': false },
          ],
          'listMsg': 'Please set the options above and Refresh',
          'listLoadText': '',

          'vehicleList': [
            // { 'vehNo': '399', 'driNo': 'DR231', 'vehicleItems': [] },
            // { 'vehNo': '420', 'driNo': 'DR267', 'vehicleItems': [] },
            // { 'vehNo': '200', 'driNo': 'DR200', 'vehicleItems': [] },
            // { 'vehNo': '100', 'driNo': 'DR959', 'vehicleItems': [] },
          ],
          'vehicleListSel': null,
          'vehicleJourneySel': null,
          'vehicleItemList': [],
          'vehicleLastSelected': [],

          'vehicleMouseEnter': false,

          'vehicleItemMouseDown': false,
          'vehicleItemMouseMove': false,
          'vehicleItemSel': null,
          'vehicleListDOM': null,
          'vehicleItemData': {
            'posX': 0,
            'curIndex': 0,
          },
        },

        selectedFilters: '',

        //-- Vehicle Data
        vehicleDetailsShow: false,
        vehicleDetailsSel: null,
        vehicleDetailsListSel: null,

        //-- Save Data
        saveShow: false,
        saveCounter: 0,
        saveCounterJourney: 0,

        //-- Discard Data
        discardShow: false,
        discardData: null,
        discardLength: 0,

        //-- Print Data
        printSelectShow: false,
        printSelectMsg: 'Loading',
        printSelectList: [],

        printShow: false,
        printData: null,
        printDataV2: null,

        //-- Resize Data
        resizeData: {
          'mouseDown': false,

          'posY': 0,
          'posYInv': 0,
        },

        //-- Map Function
        journeyView: false,
        mapView: false,
        selectedMetric: 'time',
        selectedDepartureType: 'leaveNow',
        dropOffDuration: 15,
        currentTime: null, 
        currentTimeDisplay: null,
        journeyTabItems: [
          { title: "Original Route" },
          { title: "Optimized Route", headerColor: '#00bfff' }
        ],
        journeyTabDetails: [],
        journeyTabIndex: 0,
        journeyTitle: null,
        journey: null, 
        locations: [],
        missingCoordinates: [],
        totalDuration: null,
        totalDuration2: null,
        totalHours: null,
        totalHours2: null,
        totalMinutes: null,
        totalMinutes2: null,  
        totalDistance: null,
        totalDistance2: null, 
        cumulativeDurations: [],
        estimatedTimeWODropoff: [],
        estimatedTime: [],
        optimizedWaypoints: null, 
        optimizedJourney: [],
        shareETAPopup: false,
        sharedETA: null, 
        sharedLocation: null, 
        
        //-- Loader
        loadShow: false,
        loadText: 'Loading',

        //-- Setting data types for table columns
        topTableDataTypes: {

          BalQty: 'number',
          BalWeight: 'number',
          BalM3: 'number',

          DueDate: 'date',

          PkgQty: 'number',
          PkgWeight: 'number',
          PkgUOM: 'number',
          PkgLength: 'number',
          PkgWidth: 'number',
          PkgHeight: 'number',

          OfficeHrs: 'number',  
        },

        mouseDownTime: null,

        vehicleItemRowIndex: -1,

        showDesignerV2: false,
        designerV2Data: null,
        designerV2ShowBackground: false,
        printFormatList: [ // Will need to call api after this
          { format: 'TSManifest2', value: 'TS Manifest V2', reportFile: 'TSManifestNew.json' },
          { format: 'TSManifest', value: 'TS Manifest', reportFile: 'TSManifestNew.json' },
          { format: 'WorkTicket', value: 'Work Ticket', reportFile: 'WorkTicket.json' }
        ],
        selectedPrintFormat: null,
        selectedPrintFormatError: '',
      }
    },
    computed: {
      designerV2ReportFile: function() {
        return [ this.selectedPrintFormat['reportFile'] ];
      }
    },
    async mounted() {
      //-- Test Data
      // for(var i = 0; i < 20; i++) {
      //   this.planTopData['tableData'].push({ 'name': 'John Doe', 'age': (Math.random() * 100).toFixed(0), 'occupation': 'something' });
      // }

      // this.$refs['tableMain'].selectRow([1, 2, 3]);

      //-- Set variables
      var mainDOM = this.$refs['planassignMain'];
      var resizeDOM = this.$refs['planResize'];

      //-- Set some listeners
      window.addEventListener('mouseup', (e) => { this.winMouseUp('', e); });
      window.addEventListener('mousemove', (e) => { this.winMouseMove('', e); });

      //-- Set default Resize position
      this.$set(this.resizeData, 'posY', 0.42);

      //-- Load Data
      await this.loadData();
      
      //-- Set to defaults (on startup)
      this.filterBtn('resetTable', '');
      this.filterBtn('resetVehicle', '');

      $(function(){   
        $(document).keydown(function(objEvent) {    
          if (objEvent.ctrlKey) {          
            //-- Prevents default Ctrl + A
            if (objEvent.keyCode == 65) {           
                objEvent.preventDefault();
                
                var buttonDOM = document.getElementById('selectAllBtn');
                buttonDOM.click();

                return false;
            }            
            }        
        });
      });
    },
    beforeDestroy() {
      
    },
    methods: {
      //-- Main Methods
      loadData: async function() {
        this.$set(this.planTopData, 'listLoadText', 'Loading');
        this.$set(this.planBottomData, 'listLoadText', 'Loading');
        //-- Base
        try {
          var request = await this.$apiCallV2('/PlanAndAssign/GetCoBranchBase');
          //console.log(request);          
          if (Array.isArray(request)) {
            var baseItems = request[0]['BaseList'].split(',');
            baseItems.forEach((b, i) => {
              this.planTopData['filterData']['baseItems'].push({ 'base': b });
            });
          } else { }
        } catch (e) { console.log(e); }

        //-- Team
        try {
          var request = await this.$apiCallV2('/PlanAndAssign/GetListMaster?masterFile=TEAM');
          // console.log(request);
          if (Array.isArray(request)) {
            request.forEach((t, i) => {
              this.planTopData['filterData']['teamItems'].push(t);
            });
          } else { }
        } catch (e) { console.log(e); }

        //-- JobType
        try {
          var request = await this.$apiCallV2('/PlanAndAssign/GetListMaster?masterFile=JOBTYPE&module=TMS');
          // console.log(request);
          if (Array.isArray(request)) {
            request.forEach((j, i) => {
              this.planTopData['filterData']['jobItems'].push(j);
            });
          } else { }
        } catch (e) { console.log(e); }

        //-- Drivers
        try {
          var request = await this.$apiCallV2('/PlanAndAssign/GetListMaster?masterFile=TMSDriver');
          // console.log(request);
          if (Array.isArray(request)) {
            //-- Set a default placeholder (Temporary driver)
            // this.planBottomData['filterData']['driverItems'].push({
            //   'Driver Code': 'TEMP',
            //   'Name': 'Temporary',
            //   'desc': 'Temporary (TEMP)',
            // });

            //-- Place the rest from API
            request.forEach((d, i) => {
              this.$set(d, 'desc', d['Name'] ? (d['Name'].trim() + (d['Driver Code'] ? (' (' + d['Driver Code'].trim() + ')') : '')) : '');
              this.planBottomData['filterData']['driverItems'].push(d);
            });
          } else { }
        } catch (e) { console.log(e); }

        //--Attendant
        try {
          var request = await this.$apiCallV2('/PlanAndAssign/GetListMaster?masterFile=ATTENDANT');
          console.log(request);
          if (Array.isArray(request)) {
            request.forEach((d, i) => {
              this.$set(d, 'desc', d['Attendant Name'] ? (d['Attendant Name'].trim() + (d['Attendant Code'] ? (' (' + d['Attendant Code'].trim() + ')') : '')) : '');
              this.planBottomData['filterData']['attendantItems'].push(d);
            });
          } else { }
        } catch (e) { console.log(e); }

        this.$set(this.planTopData, 'listLoadText', '');
        this.$set(this.planBottomData, 'listLoadText', '');
      },

      //-- Display Methods
      getVehicleInfo(data) {
        var vehicleNo = data['vehicleDetails']['vehNo'] ? data['vehicleDetails']['vehNo'].trim() : '';
        var vehicleCode = data['vehicleDetails']['vehCode'] ? ('(' + data['vehicleDetails']['vehCode'].trim() + ')') : '';
        var vehicleType = data['vehicleDetails']['vehType'] ? ('(' + data['vehicleDetails']['vehType'].trim() + ')')  : '';

        return vehicleNo + ' ' + vehicleCode + ' ' + vehicleType;
      },
      getJobCount(data) {
        var jobNo = 0;
        var consignmentNo = 0;
        
        Object.keys(data).forEach((j, i) => {
          jobNo += data[j]['length'];
          data[j].forEach((j2, i2) => {
            consignmentNo += j2['Consignments']['length'];
          });
        });

        // return data['length'] + (data['length'] >= 2 ? ' jobs' : ' job') + ' - ' + consignmentNo + (consignmentNo >= 2 ? ' consignments' : ' consignment');
        return 'JOUR[' + Object.keys(data)['length'] + '] ' + ' JOBS[' + jobNo + '] ' + ' CONS[' + consignmentNo + ']';
      },
      vehicleJourneySave(veh, journey) {
        var trigger = false;

        let attendantTemp = veh['attendantDetails'].length > 0 ? veh['attendantDetails'].map(a => {return a['Attendant Code']}) : [];
          console.log(attendantTemp);
          let attendantSel = veh['attCode'];
          console.log(attendantSel);
          console.log(JSON.stringify(attendantTemp));
          console.log(JSON.stringify(attendantSel));
          let compareArray = false;
          if (attendantTemp.length != attendantSel.length) {
            compareArray = true;
          }
          if (JSON.stringify(attendantTemp) == JSON.stringify(attendantSel)) {
            console.log('false');
            compareArray = false;
          } else {
            compareArray =true;
            console.log('true');
          }
        //-- Check details
        if (((veh['driverDetails']['drvSel'] ? (veh['driverDetails']['drvSel']['Driver Code'] ? veh['driverDetails']['drvSel']['Driver Code'].trim() : '') : '') 
          != (veh['driverDetails']['drvCode'] ? veh['driverDetails']['drvCode'].trim() : '')) || compareArray == true) {
          trigger = true;
        }

        console.log(journey);
        //-- Check consignments
        journey.forEach((v, i2) => {
          if (v['Consignments'].filter((c, i3) => { return (c['existing'] && c['delete']); })['length']) { trigger = true; }
          if (v['Consignments'].filter((c, i3) => { return (!c['existing']); })['length']) { trigger = true; }
          if (v['oriSeqNo'] != v['seqNo']) { trigger = true; }
        });
        
        return trigger;
      },
      vehicleListSave(veh) {
        var trigger = false;

        if (Object.keys(veh['vehicleItems'])['length'] > 0) {
          //-- Check details
          let attendantTemp = veh['attendantDetails'].length > 0 ? veh['attendantDetails'].map(a => {return a['Attendant Code']}) : [];
          let attendantSel = Object.assign([], veh['attCode']); //veh is databinding, so need to assing to new array.
          attendantTemp.sort(); //sort alpha for comparison
          attendantSel.sort(); //sort alpha for comparison

          let compareArray = false;
          if (attendantTemp.length != attendantSel.length) {
            compareArray = true;
          }
          if (JSON.stringify(attendantTemp) == JSON.stringify(attendantSel)) {
            console.log('false');
            compareArray = false;
          } else {
            compareArray =true;
            console.log('true');
          }

          if (((veh['driverDetails']['drvSel'] ? (veh['driverDetails']['drvSel']['Driver Code'] ? veh['driverDetails']['drvSel']['Driver Code'].trim() : '') : '') 
            != (veh['driverDetails']['drvCode'] ? veh['driverDetails']['drvCode'].trim() : '')) || compareArray == true) {
            trigger = true;
          }
          console.log(trigger);
          //-- Check consignments
          Object.keys(veh['vehicleItems']).forEach((j, i) => {
            veh['vehicleItems'][j].forEach((v, i2) => {
              if (v['Consignments'].filter((c, i3) => { return (c['existing'] && c['delete']); })['length']) { trigger = true; }
              if (v['Consignments'].filter((c, i3) => { return (!c['existing']); })['length']) { trigger = true; }
              if (v['oriSeqNo'] != v['seqNo']) { trigger = true; }
            });
          })
        }

        return trigger;
      },
      vehicleListSaveAll() {
        var trigger = false;

        // console.log(this.planBottomData['vehicleList']);
        this.planBottomData['vehicleList'].forEach((v, i) => {
          if (this.vehicleListSave(v)) { trigger = true; }
          // Object.keys(v['vehicleItems']).forEach((j, i2) => {
          // })
        });

        return trigger;
      },


      //---- Filter Methods
      filterBtn: async function(cmd, data, e) {
        switch(cmd) {
          case 'resetTable':
            var loginDetails = await this.$apiCallV2('/Login/GetDetails');
            var base = this.planTopData['filterData']['baseItems'].filter((b, i) => { return (b['base'] ? b['base'].trim() : '') == (loginDetails['BaseName'] ? loginDetails['BaseName'].trim() : ''); });
            this.$set(this.planTopData['filterData'], 'baseSel', (base['length'] > 0) ? base[0] : null);
            this.$set(this.planTopData['filterData'], 'teamSel', null);
            this.$set(this.planTopData['filterData'], 'jobSel', null);
            this.$set(this.planTopData['filterData'], 'legSel', { 'leg': 1 });
            this.$set(this.planTopData['filterData'], 'confirmSel', { 'confirm': 'Yes', 'value': 'Y' });
            this.$set(this.planTopData['filterData'], 'viewSel', null);
            this.$set(this.planTopData['filterData'], 'listSel', null);

            this.$set(this.planTopData['filterData'], 'weight', '0');
            this.$set(this.planTopData['filterData'], 'weightCompare', 0);
            this.$set(this.planTopData['filterData'], 'm3', '0');
            this.$set(this.planTopData['filterData'], 'm3Compare', 0);
            
            this.$set(this.planTopData['filterData'], 'jobStartDate', new Date);
            this.$set(this.planTopData['filterData'], 'jobEndDate', new Date);

            this.$set(this.planTopData['filterData']['errorMsg'], 'base', '');
            this.$set(this.planTopData['filterData']['errorMsg'], 'confirm', '');
            break;
          case 'resetVehicle':
            this.$set(this.planBottomData['filterData'], 'vehStartDate', new Date);
            this.$set(this.planBottomData['filterData'], 'vehEndDate', new Date);
            break;
          case 'show':
            if (e['target']['id'] == 'vehicleCheck') {
              if (data['vehicleItems'].filter((v, i) => { return v['selected']; })['length'] == data['vehicleItems']['length']) {
                var uneditedList = data['vehicleItems'].filter((v, i) => { 
                  var vehicleItem  = this.planBottomData['vehicleList'].filter((v2, i2) => {
                    return ((v2['vehicleDetails']['vehNo'] == (v['Lorry_No'] ? v['Lorry_No'].trim() : '')) && 
                      (v2['vehicleDetails']['vehCode'] == (v['VehicleCode'] ? v['VehicleCode'].trim() : '')) && 
                      (v2['vehicleDetails']['vehType'] ==  (v['Type'] ? v['Type'].trim() : '')));
                  });
                  if (vehicleItem['length'] > 0) { vehicleItem = vehicleItem[0]; }
                  var vehicleIndex = this.planBottomData['vehicleList'].indexOf(vehicleItem);
                  var vehicleObj = this.planBottomData['vehicleList'][vehicleIndex];

                  return !this.vehicleListSave(vehicleObj); 
                });
                // console.log(uneditedList);

                uneditedList.forEach((v, i) => {
                  this.filterBtn('fillVehicleTable', v);
                });
              } else {
                var uncheckList = data['vehicleItems'].filter((v, i) => { return !v['selected']; });
                // console.log(uncheckList['length']);
                uncheckList.forEach((v, i) => {
                  this.filterBtn('fillVehicleTable', v);
                });
              }
            } else {
              this.$set(data, 'show', !data['show']);
            }
            break;
          case 'weightCompare':
            this.$set(this.planTopData['filterData'], 'weightCompare', (this.planTopData['filterData']['weightCompare'] > 1) ? 0 : (this.planTopData['filterData']['weightCompare'] += 1))
            break;
          case 'm3Compare':
            this.$set(this.planTopData['filterData'], 'm3Compare', (this.planTopData['filterData']['m3Compare'] > 1) ? 0 : (this.planTopData['filterData']['m3Compare'] += 1))
            break;
          case 'refreshFilter':
            // this.$nextTick(() => {
            //     this.$set(this.planTopData, 'tableData', []);
            //     this.$set(this.planTopData, 'listItems', []);
            // })
            // this.$set(this.planTopData, 'tableData', []);
                // this.$set(this.planTopData, 'listItems', []);
            //-- Check for changes
            this.$set(this.planTopData, 'tableData', []);
            this.$set(this.planTopData, 'listItems', []);
            this.$set(this.planTopData, 'tableSelected', [])
            if (this.vehicleListSaveAll() && (data == 'norefresh')) {
              this.saveShow = true;
            } else {
              //-- Check for required fields
              this.$set(this.planTopData['filterData']['errorMsg'], 'base', this.planTopData['filterData']['baseSel'] ? '' : 'Base is required');
              this.$set(this.planTopData['filterData']['errorMsg'], 'confirm', this.planTopData['filterData']['confirmSel'] ? '' : 'Confirm is required');

              var errorTrigger = false;
              Object.keys(this.planTopData['filterData']['errorMsg']).forEach((e, i) => {
                if (this.planTopData['filterData']['errorMsg'][e]) { errorTrigger = true; }
              });

              if (!errorTrigger) {
                //-- Reset some data
                this.$set(this.planTopData, 'tableData', []);
                this.$set(this.planTopData, 'listItems', []);
                this.$set(this.planBottomData, 'vehicleItemList', []);
                this.$set(this.planTopData, 'listMsg', 'Refreshing');
                this.$set(this.planTopData, 'listLoadText', 'Refreshing');


                try {
                  var filterData = this.planTopData['filterData'];
                  // console.log(filterData);
                  var requestData = { 
                    'base': (filterData['baseSel'] ? (filterData['baseSel']['base'] ? filterData['baseSel']['base'] : '') : ''),
                    'wt': (filterData['weight'] ? filterData['weight'] : '0'),
                    'wtcompare': ((filterData['weightCompare'] == 0) ? '>=' : ((filterData['weightCompare'] == 1) ? '<=' : '=')),
                    'm3': (filterData['m3'] ? filterData['m3'] : '0'),
                    'm3compare': ((filterData['m3Compare'] == 0) ? '>=' : ((filterData['m3Compare'] == 1) ? '<=' : '=')),
                    'confirm': (filterData['confirmSel'] ? (filterData['confirmSel']['value'] ? filterData['confirmSel']['value'] : '') : ''),
                    'jobtype': (filterData['jobSel'] ? (filterData['jobSel']['Job Type'] ? filterData['jobSel']['Job Type'] : '') : ''),
                    'startjobdate': (filterData['jobStartDate'] ? (this.formatDatetoString(filterData['jobStartDate']).split(' ')[0]) : ''),
                    'endjobdate': (filterData['jobEndDate'] ? (this.formatDatetoString(filterData['jobEndDate']).split(' ')[0]) : ''),
                    'leg': (filterData['legSel'] ? (filterData['legSel']['leg'] ? filterData['legSel']['leg'] : '') : ''),
                    // 'filteroption': 'IMPORTANT DATE,BY CUSTOMER',
                    // 'filteroption': 'IMPORTANT DATE,BY CUSTOMER,JOB TYPE,PICK-UP BY ZONE,PICK-UP BY AREA,DROP-OFF BY ZONE,DROP-OFF BY AREA',
                    'filteroption': 'IMPORTANT DATE,BY CUSTOMER,JOB TYPE,PICK-UP BY ZONE,PICK-UP BY AREA,DROP-OFF BY ZONE,DROP-OFF BY AREA,ROUTE',
                  };
                  // console.log(requestData);

                  //--Fill filter list with incoming data
                  var request = await this.$apiCallV2('/PlanAndAssign/GetTMSJobPendingAssignment', requestData);
                  // console.log(request);
                  
                  //-- Reset some data
                  // this.$set(this.planTopData, 'tableData', []);
                  // this.$set(this.planTopData, 'listItems', []);
                  // this.$set(this.planTopData, 'tableSelected', [])
                  
                  if ((typeof request == 'object') && !Array.isArray(request)) {
                    //-- Count total consignments
                    var totalConsignment = 0;

                    //-- Format data
                    var requestData = [];
                    Object.keys(request).forEach((d, i) => {
                      var requestObj = {};
                      this.$set(requestObj, d, request[d]);
                      requestData.push(requestObj);
                    });

                    //-- Set items in the filter List
                    requestData.forEach((d, i) => {
                      //-- Filter data for certain filtering and count the total consignments
                      var filterArray = Array.isArray(d[Object.keys(d)[0]]['Filter']) ? d[Object.keys(d)[0]]['Filter'] : [d[Object.keys(d)[0]]['Filter']];
                      filterArray.forEach((f, i) => {
                        if (Array.isArray(f['Consignment']) && (f['Consignment']['length'] > 0)) {
                          this.$set(f, 'FilterFolder', Object.keys(d)[0]);

                          f['Consignment'].forEach((f2, i2) => {
                            this.$set(f2, 'strFilterFolder', Object.keys(d)[0]);

                            //-- Format dates
                            this.$set(f2, 'DueDate', (f2['DueDate'] ? this.formatDatetoString(new Date(f2['DueDate'])) : ''));
                            this.$set(f2, 'RequiredDate', (f2['RequiredDate'] ? this.formatDatetoString(new Date(f2['RequiredDate'])) : ''));
                          
                            //-- Count consignments
                            totalConsignment += 1;
                          });
                        }
                      });
                      
                      //-- Push data
                      this.planTopData['listItems'].push({ 
                        'title': Object.keys(d)[0], 
                        'show': false,
                        'filterItems': filterArray,
                        'filterAssigned': [],
                      });
                    });

                    //-- Set filter Details
                    this.$set(this.planTopData, 'tableTopDetails', [
                      [
                        { 'title': 'Base', 'value': (filterData['baseSel'] ? (filterData['baseSel']['base'] ? filterData['baseSel']['base'] : '') : '') },
                        { 'title': 'Team', 'value': (filterData['teamSel'] ? (filterData['teamSel']['Team'] ? filterData['teamSel']['Team'] : '') : '') },
                        { 'title': 'Start Date', 'value': (filterData['jobStartDate'] ? (this.formatDatetoString(filterData['jobStartDate']).split(' ')[0]) : '') },
                        { 'title': 'End Date', 'value': (filterData['jobEndDate'] ? (this.formatDatetoString(filterData['jobEndDate']).split(' ')[0]) : '') },
                      ],
                      [
                        { 'title': 'Job Type', 'value': (filterData['jobSel'] ? (filterData['jobSel']['Job Type'] ? filterData['jobSel']['Job Type'] : '') : '') },
                        { 'title': 'Leg', 'value': (filterData['legSel'] ? (filterData['legSel']['leg'] ? filterData['legSel']['leg'] : '') : '') },
                        { 'title': 'Wt (KG)', 'value': (filterData['weight'] ? filterData['weight'] : '0') },
                        { 'title': 'M3', 'value': (filterData['m3'] ? filterData['m3'] : '0') },
                      ],
                      [
                        { 'title': 'Filter Option By', 'value': '' },
                        { 'title': 'Confirm', 'value': (filterData['confirmSel'] ? (filterData['confirmSel']['value'] ? filterData['confirmSel']['value'] : '') : '') },
                        { 'title': 'Total Consignment #', 'value': totalConsignment.toFixed(0) },
                        { 'title': 'Last Refresh', 'value': (this.formatDatetoString(new Date)) },
                      ]
                    ]);
                  } else if (Array.isArray(request)) {
                    this.$set(this.planTopData, 'listMsg', request[0]['ErrMsg']);
                  } else { 
                    this.$set(this.planTopData, 'listMsg', 'An error had occured');
                  }
                } catch (e) {
                  this.$set(this.planTopData, 'listMsg', 'An error had occured');
                }

                //-- Reset some variables
                this.$set(this.planTopData, 'listLoadText', '');
              }
            }

            //-- Check for Last opened list
            if (this.planTopData['filterData']['listSel']) {
              // console.log('Last Opened Exists');
              // console.log(this.planTopData['filterData']['listSel']);

              if (this.planTopData['filterData']['listSel']['strFilterFolder']) {
                var listFolder = this.planTopData['listItems'].filter((l, i) => { return ((l['title'] ? l['title'].trim() : '') == (this.planTopData['filterData']['listSel']['strFilterFolder'] ? this.planTopData['filterData']['listSel']['strFilterFolder'].trim() : '')); });
                if (listFolder['length'] > 0) {
                  //-- Open the filter folder
                  this.$set(listFolder[0], 'show', true);
                  
                  //-- Fill the table
                  var listObj = listFolder[0]['filterItems'].filter((f, i) => { return (
                    this.planTopData['filterData']['listSel']['strFilterOption'].trim() == (f['FilterOption'] ? f['FilterOption'].trim() : '') && 
                    this.planTopData['filterData']['listSel']['strFilterItem'].trim() == (f['FilterItem'] ? f['FilterItem'].trim() : '') && 
                    this.planTopData['filterData']['listSel']['strFilterFolder'].trim() == (f['FilterFolder'] ? f['FilterFolder'].trim() : '')) });
                  if (listObj['length'] > 0) { listObj = listObj[0]; }

                  this.filterBtn('fillTable', listObj);
                }
              }
            }

            this.selectedFilters = '';
            break;
          case 'refreshVehicle':
            //-- Check for changes
            if (this.vehicleListSaveAll() && (data == 'norefresh')) {
              this.saveShow = true;
            } else {
              //-- Check for required fields
              this.$set(this.planTopData['filterData']['errorMsg'], 'base', this.planTopData['filterData']['baseSel'] ? '' : 'Base is required');

              var errorTrigger = false;
              Object.keys(this.planTopData['filterData']['errorMsg']).forEach((e, i) => {
                if (this.planTopData['filterData']['errorMsg'][e]) { errorTrigger = true; }
              });

              if (!errorTrigger) {
                //-- Reset some data
                this.$set(this.planBottomData, 'vehicleList', []);
                this.$set(this.planBottomData, 'listItems', []);
                // this.$set(this.planBottomData, 'listMsg', 'Refreshing');
                this.$set(this.planBottomData, 'listLoadText', 'Refreshing');

                try {
                  var filterData = this.planTopData['filterData'];
                  var JITMSDetails = [];

                  var JITMSDetailsData = {
                    'userid': 'dsm',
                    'cocode': '02',
                    'startjobdate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
                    'endjobdate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
                    // 'endjobdate': (this.planBottomData['filterData']['vehEndDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehEndDate']).split(' ')[0]) : ''),
                    'system': '',
                    'cu_number': '',
                    'route': '',
                    'status': '',
                  }
                  // console.log(JITMSDetailsData);

                  //-- Get existing jobs
                  var request = await this.$apiCallV2('/PlanAndAssign/GetJITMSDetails', JITMSDetailsData);

                  if (!Array.isArray(request) && (typeof request == 'object')) {
                    if (request['TMSManifest']) {
                      // console.log('%cTMSManifest', 'color: limegreen;', request['TMSManifest']);
                      JITMSDetails = request['TMSManifest']['JINO'];
                    }
                  }

                  var vehicleListData = { 
                    'base': (this.planTopData['filterData']['baseSel'] ? (this.planTopData['filterData']['baseSel']['base'] ? this.planTopData['filterData']['baseSel']['base'] : '') : ''),
                    // 'startissuedate': '2021-10-04',
                    // 'endissuedate': '2021-10-04',
                    'startissuedate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
                    'endissuedate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
                    // 'endissuedate': (this.planBottomData['filterData']['vehEndDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehEndDate']).split(' ')[0]) : ''),
                    'filtertype': 'VEHICLE WITHOUT JOBS,VEHICLE WITH JOBS,VEHICLE AT WORKSHOP',
                  };
                  // console.log(vehicleListData);

                  //--Fill vehicle list with incoming data
                  var request = await this.$apiCallV2('/PlanAndAssign/GetTMSVehicleList', vehicleListData);
                  console.log(request);

                  if (Array.isArray(request)) {
                    // console.log('%cVehicle List', 'color: limegreen;', request);
                    request.forEach((d, i) => {
                      //-- Format each item
                      var vehicleArray = Array.isArray(d['Vehicle Data']) ? d['Vehicle Data'] : [d['Vehicle Data']];
                      vehicleArray.forEach((v, i2) => {
                        // console.log(v);
                        this.$set(v, 'vehicleItems', {});

                        //-- Set existing to deletable (cancel job functionality)
                        var vehicleJobs = JITMSDetails.filter((j, i3) => { return (v['VehicleCode'] ? v['VehicleCode'].trim() : '') == (j['JHVehicleCode'] ? j['JHVehicleCode'].trim() : '') });
                        if (vehicleJobs['length'] > 0) { 
                          console.log('%c' + (v['VehicleCode'] ? v['VehicleCode'].trim() : '') + '\'s Jobs', 'color: hotpink;', vehicleJobs);
                          
                          vehicleJobs.forEach((v2, i4) => {
                            console.log(v2);
                            if ((v2['Stores']['length'] > 0)) {
                              v2['Stores'].forEach((s, i5) => {
                                //-- Generate Existing Jobs
                                var vehicleJobItem = {
                                  'JobNo': s['JobNo'] ? s['JobNo'] : '',
                                  'Cu_Number': s['Cu_Number'] ? s['Cu_Number'] : '',
                                  'Pickup': s['PickUp'] ? (s['PickUp'].trim() + (s['DepartureCode'] ? ('(' + s['DepartureCode'].trim() + ')') : '')) : (s['DepartureCode'] ? s['DepartureCode'].trim() : ''),
                                  'DepartureName': s['DepartureName'] ? s['DepartureName'].trim() : '',
                                  'PickUpLatitude': s['PickUpLatitude'] ? s['PickUpLatitude'] : '',
                                  'PickUpLongitude': s['PickUpLongtitude'] ? s['PickUpLongtitude'] : '',
                                  'DropOff': s['DropOff'] ? (s['DropOff'].trim() + (s['DestinationCode'] ? ('(' + s['DestinationCode'].trim() + ')') : '')) : (s['DestinationCode'] ? s['DestinationCode'].trim() : ''),
                                  'DestinationName': s['DestinationName'] ? s['DestinationName'].trim() : '',
                                  'DropOffLatitude': s['DropOffLatitude'] ? s['DropOffLatitude'] : '',
                                  'DropOffLongitude': s['DropOffLongtitude'] ? s['DropOffLongtitude'] : '',
                                  'M3': s['CTN'] ? s['CTN'].trim() : '',
                                  'Qty': s['Total'] ? s['Total'].trim() : '',
                                  'Weight': s['TB'] ? s['TB'].trim() : '',
                                  'JHTMSJINO': (v2['JHTMSJINO'] ? v2['JHTMSJINO'].trim() : ''),
                                  'oriSeqNo': (i5 + 1),
                                  'Consignments': [],
                                };

                                //-- Set values per Consignment
                                if (s['Consignment']['length'] > 0) {
                                  s['Consignment'].forEach((c, i6) => {
                                    //-- Set some extra data
                                    this.$set(c, 'existing', true);
                                    this.$set(c, 'Cu_Number', (s['Cu_Number'] ? s['Cu_Number'] : ''));
                                    this.$set(c, 'PUArea', (s['DepartureCode'] ? s['DepartureCode'] : ''));
                                    this.$set(c, 'DOArea', (s['DestinationCode'] ? s['DestinationCode'] : ''));
                                    
                                    this.$set(c, 'BalQty', (c['Total'] ? c['Total'].trim() : '0'));
                                    this.$set(c, 'BalWeight', (c['TB'] ? c['TB'].trim() : '0'));
                                    this.$set(c, 'PkgUOM', (c['CTN'] ? c['CTN'].trim() : '0'));
                                  });
                                }

                                this.$set(vehicleJobItem, 'Consignments', s['Consignment']);

                                this.$nextTick(() => {
                                  //-- Set some variables
                                  this.$set(v, 'drvCode', (v2['JHDriver'] ? v2['JHDriver'].trim() : ''));
                                  this.$set(v, 'attCode', [v2['JHAttendant'], v2['JHAttendant2']].filter(a => a) );
                                  console.log(v);
                                  //qyvooncontinue
                                  //-- Push item (set new key if doesn't exist)
                                  if (!v['vehicleItems'][(v2['JHTMSJINO'] ? v2['JHTMSJINO'].trim() : '')]) {
                                    this.$set(v['vehicleItems'], (v2['JHTMSJINO'] ? v2['JHTMSJINO'].trim() : ''), []);
                                  }
                                  v['vehicleItems'][(v2['JHTMSJINO'] ? v2['JHTMSJINO'].trim() : '')].push(vehicleJobItem);
                                  
                                  this.filterSetSeqNo(v['vehicleItems'][(v2['JHTMSJINO'] ? v2['JHTMSJINO'].trim() : '')]);
                                  // console.log('%cVehicle Item', 'color: lightblue;', vehicleJobItem);
                                });
                              });
                            }

                          });
                        } else {

                        }
                      });
                      
                      this.planBottomData['listItems'].push({
                        'title': d['Filter Type'] ? d['Filter Type'].trim() : '', 
                        'show': false,
                        'vehicleItems': vehicleArray,
                      });
                    });
                  } else {
                    // console.log(request);
                    this.$set(this.planBottomData, 'listMsg', 'An error had occured');
                  }

                } catch (e) { 
                  // console.log(e);
                  this.$set(this.planBottomData, 'listMsg', 'An error had occured');
                }

                //-- Reset some variables
                this.$set(this.planBottomData, 'listLoadText', '');
              }
            }

            //-- Check for last opened vehicles
            this.$nextTick(() => {
              if (this.planBottomData['vehicleLastSelected']['length'] > 0) {
                console.log('%cLast Opened Vehicles', 'color: limegreen;', this.planBottomData['vehicleLastSelected']);

                this.planBottomData['vehicleLastSelected'].forEach((v, i) => {
                  this.planBottomData['listItems'].forEach((v2, i2) => {
                    var vehicleItem = v2['vehicleItems'].filter((v3, i3) => { return (v['Lorry_No'] ? v['Lorry_No'].trim() : '') == (v3['Lorry_No'] ? v3['Lorry_No'].trim() : '') });
                    if (vehicleItem['length'] > 0) {
                      // console.log(vehicleItem[0]);
                      this.$set(v2, 'show', true);

                      this.filterBtn('fillVehicleTable', vehicleItem[0]);
                    }
                  });
                });

                this.$nextTick(() => {
                  this.$set(this.planBottomData, 'vehicleLastSelected', []);
                });
                
              }
            });

            break;
          case 'fillTable':
            this.planTopData['tableSelected'] = [];
            let myData = data['item'];
            this.selectedFilters = `${data['title']}_${myData['Id']}`;
            //-- Reset some variables

            //-- Check if item is assigned to vehicle already
            var filterItems = [];
            if (Array.isArray(myData['Consignment'])) {
              myData['Consignment'].forEach((d, i) => {
                if ((this.planBottomData['vehicleItemList'].filter((v, i) => { return (v['strFilterOption'] == d['strFilterOption'] && 
                v['strFilterItem'] == d['strFilterItem'] && v['strFilterFolder'] == d['strFilterFolder'] && v['ConsignmentNo'] == d['ConsignmentNo'])}))['length'] <= 0) {
                  filterItems.push(JSON.parse(JSON.stringify(d))); 
                }
              });
            }

            // console.log(filterItems)

            //-- Apply items to table
            this.$set(this.planTopData, 'tableData', []);
            this.$nextTick(() => {
              this.$set(this.planTopData, 'tableData', filterItems);
            })

            //-- Set selected filter
            // console.log(myData);
            this.$set(this.planTopData['filterData'], 'listSel', { 
              'strFilterOption': myData['FilterOption'], 
              'strFilterItem': myData['FilterItem'], 
              'strFilterFolder': myData['FilterFolder']
            });

            // console.log(this.planTopData['filterData']['listSel']);
            break;
          case 'fillVehicleTable':
            // console.log(data);

            //-- Clear vehicle List
            // this.$set(this.planBottomData, 'vehicleList', []);

            if (data['selected']) {
              if (this.discardShow) {
                var vehicleItem  = this.planBottomData['vehicleList'].filter((v, i) => {
                  return ((v['vehicleDetails']['vehNo'] == (data['Lorry_No'] ? data['Lorry_No'].trim() : '')) && 
                    (v['vehicleDetails']['vehCode'] == (data['VehicleCode'] ? data['VehicleCode'].trim() : '')) && 
                    (v['vehicleDetails']['vehType'] ==  (data['Type'] ? data['Type'].trim() : '')));
                });
                if (vehicleItem['length'] > 0) {
                  var vehicleIndex = this.planBottomData['vehicleList'].indexOf(vehicleItem[0]);
                  var vehicleObj = this.planBottomData['vehicleList'][vehicleIndex];

                  Object.keys(vehicleObj['vehicleItems']).forEach((j, i) => {

                  // console.log(vehicleObj['vehicleItems'][j]);
                    //-- Rearrange items in order before placing back
                    vehicleObj['vehicleItems'][j].sort((a, b) => a['oriSeqNo'] - b['oriSeqNo']);

                    //-- Reset seqNo
                    this.filterSetSeqNo(vehicleObj['vehicleItems'][j]);

                    //-- Remove vehicle from vehicle List and place back all Consignments into table
                    // console.log(vehicleObj['vehicleItems']['length']);
                    if (vehicleObj['vehicleItems'][j]['length'] > 0) {
                      vehicleObj['vehicleItems'][j].forEach(async (v, i2) => {
                        await this.tableBtn('remove', { 'vehicle': vehicleObj, 'journey': (v['JHTMSJINO'] ? v['JHTMSJINO'] : j),  'job': v, 'cmd': 'reset' });

                        //-- Remove items (some issue with one always remaining)
                        //-- Also checks for if the item was to be removed or not
                        var existingItems = v['Consignments'].filter((v2, i2) => { return v2['existing']; });
                        if (existingItems['length'] > 0) {
                          // console.log('%cExisting ', 'color: green;', JSON.parse(JSON.stringify(existingItems)));
                        } else {
                          if (vehicleObj['vehicleItems'][j]) {
                            var removableItems = v['Consignments'].filter((v2, i2) => { return !v2['existing']; });
                            // console.log('%cRemove ', 'color: red;', JSON.parse(JSON.stringify(removableItems)));
                            var jobIndex = vehicleObj['vehicleItems'][j].indexOf(v);
                            if (jobIndex >= 0) {
                              var jobObj = vehicleObj['vehicleItems'][j].splice(jobIndex, 1);
                            }

                            //-- Remove Journey item
                            if (vehicleObj['vehicleItems'][j]['length'] <= 0) {
                              delete vehicleObj['vehicleItems'][j];
                            }
                          }
                        }
                      })

                      setTimeout(() => {
                        //-- Deselect item (visual and checking purposes)
                        delete data['selected'];

                        //-- Reset Data
                        this.discardShow = false;
                        this.discardData = null;

                        //-- Remove vehicle Item from list
                        this.planBottomData['vehicleList'].splice(vehicleIndex, 1);
                      }, 1);
                      
                      // console.log(vehicleIndex);
                    }
                  });
                }
                
              } else {
                // console.log('Prompt Deletion');
                var vehicleItem  = this.planBottomData['vehicleList'].filter((v, i) => {
                  return ((v['vehicleDetails']['vehNo'] == (data['Lorry_No'] ? data['Lorry_No'].trim() : '')) && 
                    (v['vehicleDetails']['vehCode'] == (data['VehicleCode'] ? data['VehicleCode'].trim() : '')) && 
                    (v['vehicleDetails']['vehType'] ==  (data['Type'] ? data['Type'].trim() : '')));
                });
                if (vehicleItem['length'] > 0) { vehicleItem = vehicleItem[0]; }
                var vehicleIndex = this.planBottomData['vehicleList'].indexOf(vehicleItem);
                var vehicleObj = this.planBottomData['vehicleList'][vehicleIndex];

                //-- Check if require prompt (prompt for only if edits are made)
                if (this.vehicleListSave(vehicleObj)) {
                  this.discardShow = true;
                  this.discardData = data;
                } else {
                  //-- Deselect item (visual and checking purposes)
                  delete data['selected'];

                  //-- Remove vehicle Item from list
                  this.planBottomData['vehicleList'].splice(vehicleIndex, 1);
                }
              }
            } else {
              this.$set(data, 'selected', true);

              //-- Push Vehicle
              var vehicleDetails = {
                'vehicleDetails': {
                  'vehNo': (data['Lorry_No'] ? data['Lorry_No'].trim() : ''),
                  'vehCode': (data['VehicleCode'] ? data['VehicleCode'].trim() : ''),
                  'vehType': (data['Type'] ? data['Type'].trim() : ''),
                  'vehTeam': (data['Team'] ? data['Team'].trim() : ''),
                },
                'driverDetails': {
                  'drvSel': null,
                  'drvCode': '',
                  'drvErrorMsg': '',
                },
                'attendantDetails': [],
                'attCode':[],
                'vehicleItems': [],
              };
              this.planBottomData['vehicleList'].push(vehicleDetails);
              
              // this.$nextTick(() => {
                let currentIndex = this.planBottomData['vehicleList'].length - 1;

                var driverObj = this.planBottomData['filterData']['driverItems'].filter((d, i) => {
                  return ((d['Driver Code'] ? d['Driver Code'].trim() : '') == (data['drvCode'] ? data['drvCode'].trim() : ''));
                });
                var attendantObj = this.planBottomData['filterData']['attendantItems'].filter((a, i) => {
                  return data['attCode'].includes(a['Attendant Code']);
                });
                console.log(attendantObj);
                console.log(data);
                if (driverObj['length'] > 0) {
                  this.$set(this.planBottomData['vehicleList'][currentIndex]['driverDetails'], 'drvSel', driverObj[0]);
                  this.$set(this.planBottomData['vehicleList'][currentIndex]['driverDetails'], 'drvCode', (driverObj[0]['Driver Code'] ? driverObj[0]['Driver Code'].trim() : ''));
                  // this.$set(vehicleDetails['driverDetails'], 'drvSel', driverObj[0]);
                  // this.$set(vehicleDetails['driverDetails'], 'drvCode', (driverObj[0]['Driver Code'] ? driverObj[0]['Driver Code'].trim() : ''));
                }
                if (attendantObj.length > 0) {
                  this.$set(this.planBottomData['vehicleList'][currentIndex], 'attendantDetails', attendantObj);
                  this.$set(this.planBottomData['vehicleList'][currentIndex], 'attCode', data['attCode']);
                  // this.$set(vehicleDetails, 'attendantDetails', attendantObj);
                }
                //-- Get Vehicle Items
                this.$set(this.planBottomData['vehicleList'][currentIndex],  'vehicleItems', data['vehicleItems']);
                // this.$set(vehicleDetails,  'vehicleItems', data['vehicleItems']);
                console.log(vehicleDetails);

                // this.$nextTick(() => {
                  // this.planBottomData['vehicleList'].push(vehicleDetails);
                  console.log(this.planBottomData);
                // });
                    
                    
                this.filterSetSeqNo(data['vehicleItems']);
              // })
            }
            break;
        }
      },
      filterGetAssignedCount() {
        this.planTopData['listItems'].forEach((l, i) => {
          var assignCount = 0;
          this.$set(l, 'filterAssigned', []);

          l['filterItems'].forEach((f, i2) => {
            if (Array.isArray(f['Consignment'])) {
              assignCount = 0
              f['Consignment'].forEach((d, i3) => {
                assignCount += (this.planBottomData['vehicleItemList'].filter((v, i) => { return (v['strFilterOption'] == d['strFilterOption'] && 
                  v['strFilterItem'] == d['strFilterItem'] && v['strFilterFolder'] == d['strFilterFolder'] && v['ConsignmentNo'] == d['ConsignmentNo'])}))['length'];
              });
            }

            //-- Push count into field
            l['filterAssigned'].push(assignCount);
          });
        });
      },
      filterSetSeqNo: async function(vehArray) {
        if (Array.isArray(vehArray) && vehArray['length'] > 0) {
          vehArray.forEach((v, i) => {
            this.$set(v, 'seqNo', (i + 1));
          });
        }
      },

      //-- Table Methods
      tableBtn: async function(cmd, data) {
        switch(cmd) {
          case 'selectAll':
            this.showPlanTopData = false;
            if (this.planTopData['tableSelected']['length'] >= this.planTopData['tableData']['length']) { // Deselect All
              this.planTopData['tableSelected'] = [];
            } else { // Select All
              this.planTopData['tableSelected'] = [];
              this.$nextTick(() => this.planTopData['tableData'].forEach(d => this.planTopData['tableSelected'].push(d)));
            }

            this.$nextTick(() => {
              this.showPlanTopData = true;
            })
            break;
          case 'remove':
            //-- Remove item from vehicle List
            var vehIndex = this.planBottomData['vehicleList'].indexOf(data['vehicle']);
            var vehObj = this.planBottomData['vehicleList'][vehIndex];
            
            var itemIndex = vehObj['vehicleItems'][data['journey'] ? data['journey'] : this.planBottomData['vehicleJourneySel']['journey']].indexOf(data['job']);
            var itemObj = vehObj['vehicleItems'][data['journey'] ? data['journey'] : this.planBottomData['vehicleJourneySel']['journey']][itemIndex];
            
            //-- Remove Job Item
            if (itemObj['Consignments'].filter((j, i) => { return j['existing']; })['length'] <= 0 && !this.discardShow) {
              itemObj = vehObj['vehicleItems'][data['journey'] ? data['journey'] : this.planBottomData['vehicleJourneySel']['journey']].splice(itemIndex, 1)[0];
            }

            //-- Remove Journey item
            if (vehObj['vehicleItems'][data['journey'] ? data['journey'] : this.planBottomData['vehicleJourneySel']['journey']]['length'] <= 0) {
              delete vehObj['vehicleItems'][data['journey'] ? data['journey'] : this.planBottomData['vehicleJourneySel']['journey']];
            }

            //-- Place back consignments
            var deleteTrigger = false;
            if (itemObj['Consignments'].filter((j, i) => { return j['delete']; })['length'] > 0) {
              deleteTrigger = true;
            }
            itemObj['Consignments'].forEach((j, i) => {
              if (j['existing']) {
                if (j['delete'] && !deleteTrigger) {
                  this.$set(j, 'delete', false);
                } else {
                  this.$set(j, 'delete', ((data['cmd'] == 'reset') ? false : true));
                }
              } else {
                //-- Remove item from vehicle (Send back to table, if selected table is correct)
                if (this.planTopData['filterData']['listSel']['strFilterOption'].trim() == j['strFilterOption'].trim() && 
                  this.planTopData['filterData']['listSel']['strFilterItem'].trim() == j['strFilterItem'].trim() && 
                  this.planTopData['filterData']['listSel']['strFilterFolder'].trim() == j['strFilterFolder'].trim()) {
                  this.planTopData['tableData'].push(j);
                }
                
                //-- Remove from list (filter list, so that it shows again in the table);
                var filterItem = (this.planBottomData['vehicleItemList'].filter((v, i2) => { return (v['strFilterOption'] == j['strFilterOption'] && 
                  v['strFilterItem'] == j['strFilterItem'] && v['strFilterFolder'] == j['strFilterFolder'] && v['ConsignmentNo'] == j['ConsignmentNo'])}));
                if (filterItem['length'] > 0) { filterItem = filterItem[0]; }
                var filterItemIndex = this.planBottomData['vehicleItemList'].indexOf(filterItem);
                this.planBottomData['vehicleItemList'].splice(filterItemIndex, 1);
              }
            });
            
            let temp = this.planTopData['tableData'];
            this.planTopData['tableData'] = [];
            this.$nextTick(() => this.planTopData['tableData'] = temp);

            //-- Update the assign counter
            this.filterGetAssignedCount();
            break;
          case 'removeSingle':
            // console.log(data);
            //-- Remove item from vehicle List (if empty)
            var vehIndex = this.planBottomData['vehicleList'].indexOf(data['vehicle']);
            var vehObj = this.planBottomData['vehicleList'][vehIndex];
            
            var itemIndex = vehObj['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']].indexOf(data['job']);
            var itemObj = vehObj['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']][itemIndex];

            //-- Remove Job Item
            if (itemObj['Consignments']['length'] <= 1 && !data['items']['existing']) {
              itemObj = vehObj['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']].splice(itemIndex, 1)[0];
            }
            
            //-- Remove Journey item
            if (vehObj['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']]['length'] <= 0) {
              delete vehObj['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']];
            }
            
            if (data['items']['existing']) {
              if (data['items']['delete']) {
                this.$set(data['items'], 'delete', false);
              } else {
                this.$set(data['items'], 'delete', true);
              }
            } else {
              //-- Place back consignment
              var consignmentIndex = itemObj['Consignments'].indexOf(data['items']);
              var consignmentObj = itemObj['Consignments'].splice(consignmentIndex, 1)[0];

              //-- Remove item from vehicle (Send back to table, if selected table is correct)
              if (this.planTopData['filterData']['listSel']['strFilterOption'].trim() == consignmentObj['strFilterOption'].trim() && 
                this.planTopData['filterData']['listSel']['strFilterItem'].trim() == consignmentObj['strFilterItem'].trim() && 
                this.planTopData['filterData']['listSel']['strFilterFolder'].trim() == consignmentObj['strFilterFolder'].trim()) {
                this.planTopData['tableData'].push(consignmentObj);
              }
              //-- Remove from list (filter list, so that it shows again in the table);
              var filterItem = (this.planBottomData['vehicleItemList'].filter((v, i2) => { return (v['strFilterOption'] == consignmentObj['strFilterOption'] && 
                v['strFilterItem'] == consignmentObj['strFilterItem'] && v['strFilterFolder'] == consignmentObj['strFilterFolder'] && v['ConsignmentNo'] == consignmentObj['ConsignmentNo'])}));
              if (filterItem['length'] > 0) { filterItem = filterItem[0]; }
              var filterItemIndex = this.planBottomData['vehicleItemList'].indexOf(filterItem);
              this.planBottomData['vehicleItemList'].splice(filterItemIndex, 1);
            }

            //-- Update the assign counter
            this.filterGetAssignedCount();

            //-- Update Seq No
            this.filterSetSeqNo(vehObj['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']]);
            break;
          case 'vehicleSave':
            //-- Get job details
            var JITMSDetailsData = {
              'userid': 'dsm',
              'cocode': '02',
              'startjobdate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
              'endjobdate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
              // 'endjobdate': (this.planBottomData['filterData']['vehEndDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehEndDate']).split(' ')[0]) : ''),
              // 'jobdate': this.formatDatetoString(new Date()).split(' ')[0],
              'system': '',
              'cu_number': '',
              'route': '',
              'status': '',
            }

            var JITMSDetails = null;
            var request = await this.$apiCallV2('/PlanAndAssign/GetJITMSDetails', JITMSDetailsData);
            // console.log(request);

            if (!Array.isArray(request) && (typeof request == 'object')) {
              if (request['TMSManifest']) {
                // console.log('%cTMSManifest', 'color: limegreen;', request['TMSManifest']);
                JITMSDetails = request['TMSManifest']['JINO'].filter((j, i) => { return (j['JHVehicleCode'] ? j['JHVehicleCode'].trim() : '') == (data['vehicleDetails']['vehCode'] ? data['vehicleDetails']['vehCode'].trim() : '') });
                if (JITMSDetails['length'] > 0) { JITMSDetails = JITMSDetails[0]; }
              }
            }

            this.$nextTick(async () => {
              var saveData = {
                'jihaction': '',
                // 'tmsjino': (JITMSDetails ? (JITMSDetails['JHTMSJINO'] ? JITMSDetails['JHTMSJINO'] : '') : ''),
                'tmsjino': '',
                'jihind': 'N',
                'preparedby': '',
                'dateissued': (JITMSDetails ? (JITMSDetails['JHDateIssued'] ? JITMSDetails['JHDateIssued'] : (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : '')) : (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : '')),
                'timeissued': '',
                'driver': (data['driverDetails']['drvSel'] ? (data['driverDetails']['drvSel']['Driver Code'] ? data['driverDetails']['drvSel']['Driver Code'].trim() : '') : ''),
                'attendant': data['attendantDetails'] ? data['attendantDetails'].length > 0 ? data['attendantDetails'][0]['Attendant Code'] : '' : '',
                'attendant2': data['attendantDetails'] ? data['attendantDetails'].length > 1 ? data['attendantDetails'][1]['Attendant Code'] : '' : '',
                'vehiclecode': (data['vehicleDetails']['vehCode'] ? data['vehicleDetails']['vehCode'] : ''),
                'esttotalkilometer': '',
                'esttollcost': '',
                'estfuelcost': '',
                'jihremarks': '',
                // 'com_code': (data['vehicleDetails']['vehType'] ? data['vehicleDetails']['vehType'] : ''),
                'com_code': (data['driverDetails']['drvSel'] ? (data['driverDetails']['drvSel']['Com Code'] ? data['driverDetails']['drvSel']['Com Code'].trim() : '') : ''),
                'team': (data['vehicleDetails']['vehTeam'] ? data['vehicleDetails']['vehTeam'] : ''),
                'loadpercentage': '',
                'system': 'TMS',
                'jidate': (JITMSDetails ? (JITMSDetails['JHDateIssued'] ? JITMSDetails['JHDateIssued'].trim() : (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : '')) : (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : '')),
                'jitms': [],
              }

              console.log(data);
              //-- Check number of saves needed before refresh, else the refresh will spam
              Object.keys(data['vehicleItems']).forEach((j, i) => {
                if (this.vehicleJourneySave(data, data['vehicleItems'][j])) {
                  this.saveCounterJourney += 1;
                }
              });
              // console.log(this.saveCounterJourney);

              //-- Get JITMS
              console.log(Object.keys(data['vehicleItems']));
              console.log(data['vehicleItems']);
              for(var j of Object.keys(data['vehicleItems'])) {
                console.log(j);
                if (this.vehicleJourneySave(data, data['vehicleItems'][j])) {
                  //-- Set journeyNo accordingly
                  // this.$set(saveData, 'tmsjino', (Object.keys(data['vehicleItems'])[j].search('Journey') >= 0) ? '' : Object.keys(data['vehicleItems'])[j]);
                  this.$set(saveData, 'tmsjino', j || '');

                  //-- Empty the consignments
                  this.$set(saveData, 'jitms', []);

                  //-- Push in consignments (per journey)
                  var consignmentSeqNo = 1;
                  var consignmentOrderNo = 1;
                  data['vehicleItems'][j].forEach((v, i2) => {
                    consignmentOrderNo += v['Consignments']['length'];
                    v['Consignments'].forEach((c, i3) => {
                      saveData['jitms'].push({
                        'jiaction': c['existing'] ? (c['delete'] ? 'D' : 'E') : 'N',
                        // 'seqno': consignmentSeqNo,
                        'seqno': c['existing'] ? (c['SeqNo'] ? c['SeqNo'] : '') : consignmentSeqNo,
                        'jobno': (c['JobNo'] ? c['JobNo'] : ''),
                        'consignmentno': (c['ConsignmentNo'] ? c['ConsignmentNo'] : ''),
                        'legno': (c['LegNo'] ? c['LegNo'] : ''),
                        'departurecode': (v['Pickup'] ? v['Pickup'] : ''),
                        'destinationcode': (v['DropOff'] ? v['DropOff'] : ''),
                        'routeid': (c['RouteID'] ? c['RouteID'] : (c['Trip'] ? c['Trip'] : '')),
                        'estdeparturedate': (this.estimatedTime[i2] ? this.estimatedTime[i2 - 1] ? this.estimatedTime[i2 - 1].toISOString().split('T')[0] : this.estimatedTime[i2].toISOString().split('T')[0] : ''),
                        'estdeparturetime': (this.estimatedTime[i2] ? this.estimatedTime[i2 - 1] ? this.estimatedTime[i2 - 1].toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'}) : '00:00' : ''),
                        'estarrivaldate': (this.estimatedTime[i2] ? this.estimatedTime[i2].toISOString().split('T')[0] : ''),
                        'estarrivaltime': (this.estimatedTime[i2] ? this.estimatedTime[i2].toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'}) : ''),
                        'enterind': 'N',
                        'qty': (c['BalQty'] ? c['BalQty'] : '0'),
                        'weight': (c['BalWeight'] ? c['BalWeight'] : '0'),
                        'uom': c['BalM3'] ? c['BalM3'] : (c['PkgUOM'] ? c['PkgUOM'] : '0'),
                        'jiind': 'N',
                        'mvttype': (c['MvtType'] ? c['MvtType'] : (c['JobType'] ? c['JobType'] : '')),
                        // 'orderno': (c['seqNo'] ? c['seqNo'] : ''),
                        'orderno': consignmentSeqNo,
                        'jiesttollcost': '',
                        'jiestfuelcost': '',
                        'jiteam': (data['vehicleDetails']['vehTeam'] ? data['vehicleDetails']['vehTeam'] : ''),
                        'shift': '1',
                        'jiremarks': '',
                        'balweight': (c['BalWeight'] ? c['BalWeight'] : '0'),
                        'balm3': c['BalM3'] ? c['BalM3'] : (c['PkgUOM'] ? c['PkgUOM'] : '0'),
                        'balqty': (c['BalQty'] ? c['BalQty'] : '0'),
                        'dblqty': (c['BalQty'] ? c['BalQty'] : '0'),
                        'dlqtyrorig': (c['BalQty'] ? c['BalQty'] : '0'),
                        'dblweight': (c['BalWeight'] ? c['BalWeight'] : '0'),
                        'dblweightorig': (c['BalWeight'] ? c['BalWeight'] : '0'),
                        'dblm3': c['BalM3'] ? c['BalM3'] : (c['PkgUOM'] ? c['PkgUOM'] : '0'),
                        'journeyguid': '',
                      });
                      consignmentSeqNo += 1;
                    });
                  });

                  //-- Check for header indicators and determine outcome
                  var checkDelete = saveData['jitms'].filter((j2, i) => { return (j2['jiaction'] == 'D'); });
                  var checkEdit = saveData['jitms'].filter((j2, i) => { return (j2['jiaction'] == 'E'); });
                  this.$set(saveData, 'jihaction', ((checkDelete['length'] > 0) || (checkEdit['length'] > 0)) ? ((checkDelete['length'] >= saveData['jitms']['length']) ? 'D' : 'E') : 'N')
                  // this.$set(saveData, 'jihind', ((checkDelete['length'] > 0) || (checkEdit['length'] > 0)) ? ((checkDelete['length'] >= saveData['jitms']['length']) ? 'D' : 'E') : 'N')
                  
                  //-- Print output (usually very long)
                  console.log('%cPOST DATA', 'color: pink;', JSON.stringify(saveData));

                  var request = await this.$apiCallV2('/PlanAndAssign/SaveTMSAssignment', saveData, null, {message: `{{errorMessage}}`});

                  if (this.saveCounterJourney > 0) { this.saveCounterJourney -= 1 }
                  if (Array.isArray(request)) {
                    if (request[0]['Results'] <= 0) {
                      console.log('Success');
                      this.tableBtn('vehicleSaveAll', { 'status': 'return', 'errMsg': '' });
                    } else {
                      console.log(request[0]['ErrMsg']);
                      this.$bus.$emit("receivedNoti", {
                        backgroundColor: 'pink',
                        textColor: 'black',
                        from: 'API Error',
                        text: request[0]['ErrMsg']
                      });
                      this.tableBtn('vehicleSaveAll', { 'status': 'return', 'errMsg': request[0]['ErrMsg'] });
                    }
                  }

                  //-- REMOVE THIS
                  // this.tableBtn('vehicleSaveAll', { 'status': 'return', 'errMsg': '' });
                } else {
                  console.log('got error');
                }
              }
            });

            break;
          case 'vehicleSaveAll':
            //-- Change fields back to last refreshed data
            // console.log(this.planTopData['tableTopDetails']);
            this.planTopData['tableTopDetails'].forEach((f, i) => {
              //-- Reset Base
              var filter = f.filter((f2, i2) => { return f2['title'] == 'Base'; });
              if (filter['length'] > 0) {
                var base = this.planTopData['filterData']['baseItems'].filter((b, i) => { return (b['base'] ? b['base'].trim() : '') == (filter[0]['value'] ? filter[0]['value'].trim() : ''); });
                if (base['length'] > 0) {
                  this.$set(this.planTopData['filterData'], 'baseSel', (base['length'] > 0) ? base[0] : null);
                }
              }

              //-- Reset Confirm  
              var filter = f.filter((f2, i2) => { return f2['title'] == 'Confirm'; });
              if (filter['length'] > 0) {
                var value = (filter[0]['value'] ? filter[0]['value'].trim() : '');
                if (filter[0]['value']) {
                  this.$set(this.planTopData['filterData'], 'confirmSel', { 'confirm': (value == 'Y' ? 'Yes' : 'No'), 'value': value });
                }
              }
            });
            switch(data['status']) {
              case 'check':
                //-- Check for any empty vehicle Fields (as of now, checking if Driver is empty)
                var nullTrigger = false;
                this.planBottomData['vehicleList'].forEach((v, i) => {
                  //-- Check if vehicle had assigned Driver but no items (Skip saving this item)
                  var trigger = false;
                  if (v['vehicleItems']['length'] <= 0) { trigger = true; }


                  if (!trigger && !v['driverDetails']['drvSel']) {
                    nullTrigger = true;
                    this.$set(v['driverDetails'], 'drvErrorMsg', 'Driver is Required');
                  }
                  if (!nullTrigger && !trigger && v['driverDetails']['drvSel']) {
                    if (v['attendantDetails']) {
                      v['attendantDetails'].forEach(a => {
                        if (v['driverDetails']['drvSel']['Driver Code'].trim() == a['Attendant Code'].trim()) {
                          nullTrigger = true;
                          this.$set(v['driverDetails'], 'drvErrorMsg', 'Cannot same with Attendant');
                        }
                      });
                    }
                  }
                });
                
                if (!nullTrigger) {
                  //-- Save all edited
                  for (let v of this.planBottomData['vehicleList']) { //change to this method from foreach because this can use await whereas foreach cannot
                    //-- Set items for Last open (to reopen when refreshed)
                    var vehItem = {
                      'Lorry_No': (v['vehicleDetails']['vehNo'] ? v['vehicleDetails']['vehNo'].trim() : ''),
                      'VehicleCode': (v['vehicleDetails']['vehCode'] ? v['vehicleDetails']['vehCode'].trim() : ''),
                      'Type': (v['vehicleDetails']['vehType'] ? v['vehicleDetails']['vehType'].trim() : ''),
                    }

                    this.planBottomData['vehicleLastSelected'].push(vehItem);

                    //-- Save if edited
                    if (this.vehicleListSave(v)) {
                      this.saveCounter += 1;
                      await this.tableBtn('vehicleSave', v);
                    }
                  }
                  // this.planBottomData['vehicleList'].forEach(async (v, i) => {
                    
                  // });

                  //-- Set Loader
                  if (this.saveCounter > 0) {
                    this.loadShow = true;
                    this.loadText = 'Saving';
                  }
                  
                }
                break;
              case 'return':
                // console.log('Returning Call' + (data['errMsg'] ? (': ' + data['errMsg']) : ''));
                // console.log(this.saveCounter);

                if (this.saveCounter > 0) { this.saveCounter -= 1; } 
                
                if (this.saveCounter <= 0) {
                  // console.log('Done');

                  //-- Reset Loader
                  this.loadShow = false;
                  this.loadText = 'Loading';

                  //-- Refresh both top and bottom halves
                  if (this.saveCounterJourney <= 0) {
                    console.log('Refresh');
                    this.filterBtn('refreshFilter', '');
                    this.filterBtn('refreshVehicle', '');
                  }
                }
                
                break;
            }
            break;
          case 'vehiclePrint':
            function padNumber(number) {
              if (number < 10) {
                return `0${number}`;
              } else {
                return number;
              }
            }

            //#region V1 Only
            // data = this.$deepTrimJsonV3(data);
            // console.log(JSON.parse(JSON.stringify(data)));

            // let totalPages = Math.ceil(data['Stores'].length / 3);
            // let newStores = [];
            // data['Stores'].forEach((s, i) => {
            //   let cns = s['Consignment'];
            //   if (cns.length > 8) {
            //     let loop = Math.ceil(cns.length / 8);
            //     for (let x = 0; x < loop; x++) {
            //       let start = 8 * x;
            //       let end = start + 8;

            //       let store = JSON.parse(JSON.stringify(s));
            //       store['Consignment'] = cns.slice(start, end);
            //       store['DropSeqNo'] = i + 1;
            //       newStores.push(store);
            //     }
            //   } else {
            //     s['DropSeqNo'] = i + 1;
            //     newStores.push(s);
            //   }
            // });
            // data['Stores'] = newStores;
            // data['Stores'].forEach((d, i) => {
            //   d['page'] = `${padNumber(Math.ceil((i + 1) / 3))}/${padNumber(totalPages)}`;
            // });
            
            // this.printShow = true;
            // this.$nextTick(() => {
            //   //-- Set data
            //   // this.$set(this.printData, 'vehicleItems', JSON.parse(JSON.stringify(data)));
            //   this.printData = JSON.parse(JSON.stringify(data));
            // });
            //#endregion
            
            //#region Handle for work ticket
            if (!this.selectedPrintFormat) {
              this.selectedPrintFormatError = 'Print Format is Required!';
              return;
            }
            
            if (this.selectedPrintFormat['format'] == 'TSManifest' || this.selectedPrintFormat['format'] == 'TSManifest2') { // Printing TSManifest
              data = JSON.parse(JSON.stringify(this.$deepTrimJsonV3(data)));

              let totalPages = Math.ceil(data['Stores'].length / 3);
              let newStores = [];
              data['Stores'].forEach((s, i) => {
                let cns = s['Consignment'];
                if (cns.length > 8) {
                  let loop = Math.ceil(cns.length / 8);
                  for (let x = 0; x < loop; x++) {
                    let start = 8 * x;
                    let end = start + 8;

                    let store = JSON.parse(JSON.stringify(s));
                    store['Consignment'] = cns.slice(start, end);
                    store['DropSeqNo'] = i + 1;
                    newStores.push(store);
                  }
                } else {
                  s['DropSeqNo'] = i + 1;
                  newStores.push(s);
                }
              });
              data['Stores'] = newStores;
              data['Stores'].forEach((d, i) => {
                d['page'] = `${padNumber(Math.ceil((i + 1) / 3))}/${padNumber(totalPages)}`;
              });
              
              if (this.selectedPrintFormat['format'] == 'TSManifest') { // V1 Print
                this.printShow = true;
                this.$nextTick(() => {
                  //-- Set data
                  // this.$set(this.printData, 'vehicleItems', JSON.parse(JSON.stringify(data)));
                  this.printData = JSON.parse(JSON.stringify(data));
                });
              } else { // V2 Print
                this.printDataV2 = JSON.parse(JSON.stringify(data));
                if (this.printDataV2['Stores']) {
                  this.printDataV2['Stores'].forEach((s, i) => {
                    s['bottomRightDetails'] = `${this.printDataV2['JHTMSJINO']} Page ${s['page']} (${(i % 3) + 1}/3)`;
                    if (Array.isArray(s['Consignment'])) {
                      s['istMerge'] = s['Consignment'].map(c => c['IST No']).join('\n');
                      s['truckManifestMerge'] = s['Consignment'].map(c => c['Manifest No']).join('\n');
                      s['truckManifestQR'] = `https://api.qrserver.com/v1/create-qr-code/?data=${JSON.stringify({ CNNO: s['Consignment'][0]['ConsignmentNo'] })}&amp;size=150x150`;
                    }
                  })
                }

                this.designerV2ShowBackground = false;
                this.designerV2Data = this.printDataV2;
                this.showDesignerV2 = true;
              }
            } else if (this.selectedPrintFormat['format'] == 'WorkTicket') { // Printing Work Ticket
              data = this.$deepTrimJsonV3(data);
              let allConsigments = data['Stores'].map(s => {
                let consignment = s['Consignment'];
                consignment.forEach(c => {
                  c['DepartureCode'] = s['DepartureCode'];
                  c['DepartureName'] = s['DepartureName'];
                  c['DestinationCode'] = s['DestinationCode'];
                  c['DestinationName'] = s['DestinationName'];
                  c['DepartureArea'] = s['DepartureArea'];
                  c['DestinationArea'] = s['DestinationArea'];
                  c['FinalDestination'] = s['FinalDestination'];
                  c['Cu_Number'] = s['Cu_Number'];
                })

                return consignment;
              });
              allConsigments = allConsigments.flat(Number.POSITIVE_INFINITY);
              allConsigments.forEach((c, i) => {
                c['#'] = i + 1; // Format the numbering
                c['totalPkgs'] = Number(c['TB']) + Number(c['CTN']); // Format total packages
                c['consignorConsignee'] = `${c['DepartureCode']} ${c['DepartureName']}\n${c['DestinationCode']} ${c['DestinationName']} ${c['FinalDestination'] || ''}`; // Format Consignor/Consginee
                c['fromTo'] = `${c['DepartureArea']}\n${c['DestinationArea']}`;
              });
              
              data['consignments'] = allConsigments;
              data['printDate'] = new Date().formatString('dd/MM/yyyy');
              let getHours = Number(new Date().formatString('HH'));
              data['printTime'] = `${getHours}:${new Date().formatString('mm:ss')}${getHours < 12 ? 'AM' : 'PM'}`;
              data['preparedBy'] = (await this.$apiCallV2('/Login/GetDetails'))['LoginUserId'];
              data['totalPkg'] = allConsigments.map(c => Number(c['totalPkgs'])).reduce((a, b) => a + b, 0);
              data['totalTB'] = allConsigments.map(c => Number(c['TB'])).reduce((a, b) => a + b, 0);
              data['totalCTN'] = allConsigments.map(c => Number(c['CTN'])).reduce((a, b) => a + b, 0);
              
              this.designerV2ShowBackground = true;
              this.designerV2Data = data;
              this.showDesignerV2 = true;
            }
            //#endregion
            break;
          case 'vehicleSelectOpen':
            var postData = {
              'userid': 'dsm',
              'cocode': '02',
              'startjobdate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
              'endjobdate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
              // 'jobdate': (this.planBottomData['filterData']['vehStartDate'] ? (this.formatDatetoString(this.planBottomData['filterData']['vehStartDate']).split(' ')[0]) : ''),
              'system': '',
              'cu_number': '',
              'route': '',
              'status': '',
            }

            //-- Show the selection popup
            this.printSelectShow = true;
            this.printSelectMsg = 'Loading';
            this.printSelectList = [];

            var request = await this.$apiCallV2('/PlanAndAssign/GetJITMSDetails', postData);
            // console.log(request);

            if (!Array.isArray(request) && (typeof request == 'object')) {
              if (request['TMSManifest']) {
                // console.log(request['TMSManifest']);
                if (request['TMSManifest']['JINO']['length'] > 0) {
                  request['TMSManifest']['JINO'].forEach( async (j, i) => {
                    var request2 = await this.$apiCallV2('/PlanAndAssign/GetVehicleDriverDetails?vehiclecode=' + j['JHVehicleCode']);
                    // console.log(request2);

                    if (Array.isArray(request2)) {
                      //-- Set extra details
                      this.$set(j, 'Lorry_No', (request2['length'] > 0) ? (request2[0]['Lorry_No'] ? request2[0]['Lorry_No'].trim() : '') : '');
                      this.$set(j, 'OwnerShip', (request2['length'] > 0) ? (request2[0]['OwnerShip'] ? request2[0]['OwnerShip'].trim() : '') : '');
                    }

                    //-- Set Driver Details
                    var driverItem = this.planBottomData['filterData']['driverItems'].filter((d, i2) => { return ((d['Driver Code'] ? d['Driver Code'].trim() : '') == (j['JHDriver'] ? j['JHDriver'].trim() : '')); });
                    
                    this.$set(j, 'DriverName', (driverItem['length'] > 0) ? (driverItem[0]['Name'] ? driverItem[0]['Name'].trim() : '') : '');

                    //-- Push item in for preview and selection
                    this.printSelectList.push(j);
                  });
                } else {
                  this.printSelectMsg = 'No Records Found';
                }
              }
            } else if (Array.isArray(request) && request['length'] > 0) {
              if (request[0]['Results'] > 0) {
                this.printSelectMsg = request[0]['ErrMsg'];
              }
            }
            break;
          case 'vehicleSelectCancel':
            this.printSelectShow = false;
            break;
          case 'showDetails':
            this.vehicleItemRowIndex = data['rowIndex'];
            console.log(data['job']);
            
            data['job']['Consignments'].forEach(c =>{
              c['updating'] = false;
              c['newWeight'] = c['TB'] ? c['TB'] : (c['BalWeight'] ? c['BalWeight'] : 0),
              c['newM3'] = c['CTN'] ? c['CTN'] : (c['BalM3'] ? c['BalM3'] : 0),
              c['newQty'] = Number(c['newWeight']) + Number(c['newM3'])
            });
            //-- Show popup
            this.vehicleDetailsShow = true;
            this.vehicleDetailsSel = JSON.parse(JSON.stringify(data['vehicle']));
            this.vehicleDetailsListSel = JSON.parse(JSON.stringify(data['job']));
            break;
          case 'hideDetails':
            //-- Hide popup
            this.vehicleDetailsShow = false;
            this.vehicleDetailsSel = null;
            this.vehicleDetailsListSel = null;
            break;
          case 'discardCancel':
            this.discardShow = false;
            break;
          case 'discardChanges':
            
            this.filterBtn('fillVehicleTable', this.discardData);
            break;
          case 'test':
            console.log(this.planBottomData.vehicleList);
            break;
        }
      },

      //-- Save Methods
      saveBtn: async function(cmd, data) {
        switch(cmd) {
          case 'cancel':
            this.saveShow = false;
            break;
          case 'discard':
            //-- Set items for Last open (to reopen when refreshed)
            this.planBottomData['vehicleList'].forEach((v, i) => {
              var vehItem = {
                'Lorry_No': (v['vehicleDetails']['vehNo'] ? v['vehicleDetails']['vehNo'].trim() : ''),
                'VehicleCode': (v['vehicleDetails']['vehCode'] ? v['vehicleDetails']['vehCode'].trim() : ''),
                'Type': (v['vehicleDetails']['vehType'] ? v['vehicleDetails']['vehType'].trim() : ''),
              }

              this.planBottomData['vehicleLastSelected'].push(vehItem);
            });

            this.saveShow = false;
            this.filterBtn('refreshFilter', '');
            this.filterBtn('refreshVehicle', '');
            break;
          case 'save':
            this.saveShow = false;
            this.tableBtn('vehicleSaveAll', { 'status': 'check', 'errMsg': '' });
            break;
        }
      },

      //---- Listener Methods
      winMouseUp: async function(cmd, e) {
        this.$set(this.resizeData, 'mouseDown', false);

        //-- Drop item into vehicle List
        if (this.planBottomData['vehicleList']['length'] > 0 && !this.planBottomData['vehicleItemMouseDown']) {
          if (this.planBottomData['vehicleListSel']) {
            // console.log(this.planBottomData['vehicleListSel']);
            // console.log(this.planBottomData['vehicleJourneySel']);
            if (this.planBottomData['vehicleJourneySel']) {
              this.planTopData['tableSelected'].forEach((d, i) => {
                var tableItemIndex = this.planTopData['tableData'].indexOf(d);
                this.planTopData['tableData'].splice(tableItemIndex, 1);
                
                this.planBottomData['vehicleItemList'].push({
                  'strFilterOption': (d['strFilterOption'] ? d['strFilterOption'] : ''),
                  'strFilterItem': (d['strFilterItem'] ? d['strFilterItem'] : ''),
                  'strFilterFolder': (d['strFilterFolder'] ? d['strFilterFolder'] : ''),
                  'ConsignmentNo': (d['ConsignmentNo'] ? d['ConsignmentNo'] : ''),
                });
                
                //-- Set New Journey
                if (this.planBottomData['vehicleJourneySel']['journey'] == 'new') {
                  // console.log(this.planBottomData['vehicleListSel']);
                  this.$set(this.planBottomData['vehicleListSel']['vehicleItems'], ('Journey' + (Object.keys(this.planBottomData['vehicleListSel']['vehicleItems'])['length'] + 1)), []);

                  //-- Set selected Journey
                  this.$set(this.planBottomData['vehicleJourneySel'], 'journey', ('Journey' + Object.keys(this.planBottomData['vehicleListSel']['vehicleItems'])['length']));
                }

                // console.log(this.planBottomData['vehicleListSel']['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']]);
                var vehicleJobItem = this.planBottomData['vehicleListSel']['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']].filter((j, i2) => { return (j['JobNo'] ? j['JobNo'] : '') == d['JobNo']; });
                if (vehicleJobItem['length'] > 0) {
                  vehicleJobItem[0]['Consignments'].push(d);

                  //-- Get total M3, Qty, Weight
                  this.$set(vehicleJobItem[0], 'M3', 0);
                  this.$set(vehicleJobItem[0], 'Qty', 0);
                  this.$set(vehicleJobItem[0], 'Weight', 0);
                  vehicleJobItem[0]['Consignments'].forEach((c, i2) => {
                    this.$set(vehicleJobItem[0], 'M3', vehicleJobItem[0]['M3'] + (c['BalM3'] ? parseFloat(c['BalM3']) : 0));
                    this.$set(vehicleJobItem[0], 'Qty', vehicleJobItem[0]['Qty'] + (c['BalQty'] ? parseFloat(c['BalQty']) : 0));
                    this.$set(vehicleJobItem[0], 'Weight', vehicleJobItem[0]['Weight'] + (c['BalWeight'] ? parseFloat(c['BalWeight']) : 0));
                  });
                } else {
                  this.planBottomData['vehicleListSel']['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']].push({
                    'JobNo': d['JobNo'] ? d['JobNo'] : '',
                    'Cu_Number': d['Cu_Number'] ? d['Cu_Number'] : '',
                    'Pickup': d['Pickup'] ? d['Pickup'].trim() : '',
                    'DropOff': d['DropOff'] ? d['DropOff'].trim() : '',
                    'PickupDesc': d['Pickup'] ? (d['Pickup'].trim() + (d['PUArea'] ? ('(' + d['PUArea'].trim() + ')') : '')) : '',
                    'DropOffDesc': d['DropOff'] ? (d['DropOff'].trim() + (d['DOArea'] ? ('(' + d['DOArea'].trim() + ')') : '')) : '',
                    'M3': d['BalM3'],
                    'Qty': d['BalQty'],
                    'Weight': d['BalWeight'],
                    'Consignments': [d],
                  });
                }
              });

              let temp = this.planTopData['tableData'];
              this.planTopData['tableData'] = [];
              this.$nextTick(() => {
                this.planTopData['tableData'] = temp;
                this.planTopData['tableSelected'] = [];
              });

              //-- Update the assign counter
              this.filterGetAssignedCount();

              //-- Update the seqNo
              this.filterSetSeqNo(this.planBottomData['vehicleListSel']['vehicleItems'][this.planBottomData['vehicleJourneySel']['journey']]);
            }
          }
        }
        
        //-- Table Reset
        this.$set(this.planTopData, 'tableMouseDown', false);
        this.$set(this.planTopData, 'tableMouseMove', false);

        //-- Vehicle Item Drag Reset
        this.vehicleItemsMouseLeave('', e);

        //-- Vehicle Reset (dragging etc)
        this.$set(this.planBottomData, 'vehicleMouseEnter', false);
        this.$nextTick(() => {
          this.$set(this.planBottomData, 'vehicleListSel', null);
        });
      },
      winMouseMove: async function(cmd, e) {
        if (this.resizeData['mouseDown']) {
          //-- Set variables
          var mainDOM = this.$refs['planassignMain'];
          
          var newSize = (1 - ((e['layerY'] - 6) / mainDOM.getBoundingClientRect()['height']));
          var min = 0.05;
          var max = 0.95
          this.$set(this.resizeData, 'posY', (newSize < min ? min : (newSize > max ? max : newSize)));
        }

        //-- Move table dragging tooltip
        if (this.planTopData['tableMouseDown'] && (this.planTopData['tableSelected']['length'] > 0) && (this.planTopData['tableData']['length'] > 0)) {
          this.$set(this.planTopData, 'tableMouseMove', true);

          this.$nextTick(() => {
            //-- Set variables
            var tooltipDOM = this.$refs['tooltipMove'];
            // console.log(tooltipDOM);

            //-- Move the tooltip (to show data being dragged)
            // console.log(e);
            tooltipDOM['style']['left'] = ((e['x'] + 20) + 'px');
            tooltipDOM['style']['top'] = (e['y'] + 'px');
          });
        }

        //-- Move Vehicle Item
        if (this.planBottomData['vehicleItemMouseDown'] && this.planBottomData['vehicleItemSel']) {
          this.$set(this.planBottomData, 'vehicleItemMouseMove', true);

          this.$nextTick(() => {
            //-- Set variables
            var tooltipDOM = this.$refs['tooltipMove2'];
            // console.log(tooltipDOM);

            //-- Move the tooltip (to show data being dragged)
            // console.log(e);
            tooltipDOM['style']['left'] = ((e['x'] + 20) + 'px');
            tooltipDOM['style']['top'] = (e['y'] + 'px');

            //-- Reposition (index)
            if (e['target']['id'] == this.planBottomData['vehicleJourneySel']['journey']) {
              var itemWidth = 150;
              if ((Math.floor((e['layerX'] + this.planBottomData['vehicleListDOM']['scrollLeft']) / itemWidth) != this.planBottomData['vehicleItemData']['curIndex'])) {
                this.$set(this.planBottomData['vehicleItemData'], 'curIndex', Math.floor((e['layerX'] + this.planBottomData['vehicleListDOM']['scrollLeft']) / itemWidth));

                var itemIndex = this.planBottomData['vehicleJourneySel']['items'].indexOf(this.planBottomData['vehicleItemSel']);
                if (itemIndex >= 0) {
                  //-- Retrieve Item
                  var itemObj = this.planBottomData['vehicleJourneySel']['items'].splice(itemIndex, 1)[0];
                  
                  //-- Insert Item into new index
                  this.planBottomData['vehicleJourneySel']['items'].splice(Math.floor((e['layerX'] + this.planBottomData['vehicleListDOM']['scrollLeft']) / itemWidth), 0, itemObj);
                }

                this.filterSetSeqNo(this.planBottomData['vehicleJourneySel']['items']);
              }
            }
          });
        }
      },

      //---- Resize Methods
      resizeMouseDown: async function(cmd, e) {
        this.$set(this.resizeData, 'mouseDown', true);
      },

      //---- Table Methods
      tableMouseDown: async function(cmd, e) {
        this.mouseDownTime = new Date().getTime();
        setTimeout(() => {
          if (this.mouseDownTime) {
            this.$set(this.planTopData, 'tableMouseDown', true);
          }
        }, 500);
      },
      tableMouseUp: function() {
        this.mouseDownTime = null;
        this.$set(this.planTopData, 'tableMouseDown', false);
      },
      rowSelected: function(data, selected) {
        if (!this.planTopData['tableAssignByJob']) { return }

        let temp = this.planTopData['tableSelected'];
        this.showPlanTopData = false;
        this.planTopData['tableSelected'] = [];

        if (selected) {
          let allSelect = this.planTopData['tableData'].filter(t => t['JobNo'] == data['JobNo']);

          let index = temp.indexOf(data);
          temp.splice(index, 1);
          this.$nextTick(() => {
            this.planTopData['tableSelected'] = temp.concat(allSelect);
          })
        } else {
          let allDeselect = temp.filter(t => t['JobNo'] == data['JobNo']);
          allDeselect.forEach(d => {
            let index = temp.indexOf(d);
            temp.splice(index, 1);
          });
          this.$nextTick(() => {
            this.planTopData['tableSelected'] = temp;
          });
        }

        this.$nextTick(() => {
          this.showPlanTopData = true;
        })
      },

      //---- Vehicle Methods
      vehicleMouseLeave: async function(cmd, e) {
        this.$set(this.planBottomData, 'vehicleMouseEnter', false);
        this.$set(this.planBottomData, 'vehicleListSel', null);
      },
      vehicleMouseEnter: async function(cmd, e) {
        if (this.planTopData['tableMouseMove']) {
          this.$set(this.planBottomData, 'vehicleMouseEnter', true);
        }
      },
      vehicleItemMouseLeave: async function(cmd, e) {
        this.$set(this.planBottomData, 'vehicleListSel', null);
      },
      vehicleItemMouseEnter: async function(cmd, data) {
        if (this.planTopData['tableMouseMove']) {              
          this.$set(this.planBottomData, 'vehicleListSel', data);

          // var vehicleDOM = document.getElementById(cmd);
          
          // console.log(vehicleDOM);
        }
      },
      vehicleItemsMouseLeave: async function(cmd, e) {
        //-- Remove highlight key
        if (this.planBottomData['vehicleItemSel']) {
          delete this.planBottomData['vehicleItemSel']['dragging'];
        }

        //-- Reset others
        this.$set(this.planBottomData, 'vehicleItemMouseDown', false);
        this.$set(this.planBottomData, 'vehicleItemMouseMove', false);
        this.$set(this.planBottomData, 'vehicleItemSel', null);
      },
      vehicleItemMouseDown: async function(cmd, list, data, e) {
        if (e['target']['id'] == 'vehicleItem' || e['target']['id'] == 'vehicleItemConsignment') {
          //-- Set a highlight key
          this.$set(data, 'dragging', true);

          this.$set(this.planBottomData, 'vehicleItemMouseDown', true);
          this.$set(this.planBottomData, 'vehicleItemMouseMove', true);
          this.$set(this.planBottomData, 'vehicleItemSel', data);
          this.$set(this.planBottomData, 'vehicleListSel', list);
          this.$set(this.planBottomData, 'vehicleListDOM', e['target']['parentNode']);

          //-- Set variables
          var listDetails = e['target']['parentNode'].getBoundingClientRect();
          var itemDetails = e['target'].getBoundingClientRect();
          
          this.$set(this.planBottomData['vehicleItemData'], 'posX', (itemDetails['left'] - listDetails['left']) + this.planBottomData['vehicleListDOM']['scrollLeft']);
          this.$set(this.planBottomData['vehicleItemData'], 'curIndex', Math.floor(((itemDetails['left'] - listDetails['left']) + this.planBottomData['vehicleListDOM']['scrollLeft']) / 150));
          // console.log(Math.floor(((itemDetails['left'] - listDetails['left']) + this.planBottomData['vehicleListDOM']['scrollLeft']) / 145));
        }
      },
      vehicleJourneyMouseOver: async function(journey, items, e) {
        var journeyItem = { 'journey': journey, 'items': items }
        this.$set(this.planBottomData, 'vehicleJourneySel', journeyItem);
      },
      vehicleJourneyMouseLeave: async function(cmd, e) {
        this.$set(this.planBottomData, 'vehicleJourneySel', null);
      },

      //-------- Utility Methods
      formatDatetoString: function (date) {
        if (typeof date == 'string') {
          //console.log(date);
          var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '').replace(/\-/g, '-');
          try {
            var dateFF = new Date(dateF);
            if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
          } catch (e) { /*console.log(e);*/ }
        } else {
          var dateFF = date;
        }
        
        var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
        var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
        var y = dateFF.getFullYear();
        var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
        var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

        return `${y}-${m}-${d} ${hh}:${mm}`;
      },
      formatStringtoDate: function (date) {
        var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
        var dateFF = dateF.split('/');
        return new Date(dateFF[0], (parseInt(dateFF[1]) - 1).toString(), dateFF[2], dateFF[3], dateFF[4]);
      },
      //-- Tabulator Method
      processJourney: function(vehicleItems, journeyTitle) {
        console.log('processJourney - vehicleItems');
        console.log(vehicleItems);
        this.estimatedTime = [];
        this.journeyView = true;
        this.currentTime = new Date();
        this.currentTimeDisplay = this.currentTime.toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'});
        this.journeyTitle = journeyTitle;
        // let uniqueDropoff = vehicleItems.map(x => x);
        // if (uniqueDropoff.some(x => x['DropOffLatitude'] === '0.0000') || uniqueDropoff.some(x => x['PickUpLatitude'] === '0.0000')) {
        //   uniqueDropoff.forEach(x => {
        //     if (x['DropOffLatitude'] === '0.0000' || x['PickUpLatitude'] === '0.0000')
        //       this.missingCoordinates.push(x['DestinationName']);
        //   });
        // }
        // else {
        //   uniqueDropoff = vehicleItems.filter((value, index, self) => 
        //     index === self.findIndex((t) => (
        //       t['DropOffLatitude'] === value['DropOffLatitude'] && t['DropOffLongitude'] === value['DropOffLongitude']
        //     ))
        //   ); 
        // }
        // this.locations.push({'lat': vehicleItems[0]['PickUpLatitude'], 'lng': vehicleItems[0]['PickUpLongitude'], 'name': vehicleItems[0]['DepartureName'], 'key' : 0});
        // uniqueDropoff.forEach((x, i) => this.locations.push({'lat': x['DropOffLatitude'], 'lng': x['DropOffLongitude'], 'name': x['DestinationName'], 'key': (i + 1)}));
        if (vehicleItems.some(x => x['DropOffLatitude'] === '0.0000') || vehicleItems.some(x => x['PickUpLatitude'] === '0.0000')) {
          vehicleItems.forEach(x => {
            if (x['DropOffLatitude'] === '0.0000' || x['PickUpLatitude'] === '0.0000')
              this.missingCoordinates.push(x['DestinationName']);
          });
        }
        this.locations.push({'lat': vehicleItems[0]['PickUpLatitude'], 'lng': vehicleItems[0]['PickUpLongitude'], 'name': vehicleItems[0]['DepartureName'], 'key' : 0});
        vehicleItems.forEach((x, i) => this.locations.push({'lat': x['DropOffLatitude'], 'lng': x['DropOffLongitude'], 'name': x['DestinationName'], 'key': (i + 1)}));
        // console.log('this.locations');
        // console.log(this.locations);
        if (this.locations.length > 25) {
          console.error(`Too many waypoints in the request (${this.locations.length - 2}). The maximum allowed waypoints for this request is 25, plus the origin, and destination.`);
          this.$showAlert(
            'warning',
            "Sorry",
            `Too Many Waypoints. Maximum: 25 Waypoints`,
          );
          this.journeyTabItems.splice(this.journeyTabItems.findIndex(x => x.title === "Optimized Route"), 1);
          this.$refs.gmap.mSetJourney(null, this.journeyTabIndex);
        }
        else if (this.missingCoordinates.length > 0) {
          this.$showAlert(
            'warning',
            "Sorry",
            `Missing Coordinates For ${this.missingCoordinates.toString()}`,
          )
          this.journeyTabItems.splice(this.journeyTabItems.findIndex(x => x.title === "Optimized Route"), 1);
          this.$refs.gmap.mSetJourney(null, this.journeyTabIndex);
        }
        else 
          this.$refs.gmap.mSetJourney(this.locations, this.journeyTabIndex);
      },
      getDirections: function(directions) {
        this.locations.forEach((x, i) => this.optimizedJourney.push({'lat': x['lat'], 'lng': x['lng'], 'name': x['name'], 'key': i}));
        // console.log('this.optimizedJourney');
        // console.log(this.optimizedJourney);
        if (directions) {
          // console.log('getDirections - directions');
          // console.log(directions);
          let durations = directions['routes'][0]['legs'].map(x => x['duration']['value']);
          let distances = directions['routes'][0]['legs'].map(x => x['distance']['value']);
          this.totalDuration = new Date(null);
          let durationSum = durations.reduce((a, b) => a + b, 0);
          this.totalDuration.setSeconds(durationSum);
          this.totalDistance = (distances.reduce((a, b) => a + b, 0) / 1000).toFixed(1);
          durations.unshift(0);
          // console.log('durations');
          // console.log(durations);
          durations.reduce((a,b,i) => { return this.cumulativeDurations[i] = a + b; }, 0);
          // console.log('this.cumulativeDurations');
          // console.log(this.cumulativeDurations);
          this.estimatedTimeWODropoff = this.cumulativeDurations.map(x => new Date(this.currentTime.getTime() + x * 1000));
          this.estimatedTime = this.estimatedTimeWODropoff.map(x => x);
          // console.log('this.estimatedTime');
          // console.log(this.estimatedTime);
          for (let i = 1; i < this.estimatedTime.length; i++) {
            this.estimatedTime[i] = new Date(this.estimatedTime[i].getTime() + this.dropOffDuration * 60 * 1000 * (i - 1));
          }
          // console.log('this.estimatedTime - modified');
          // console.log(this.estimatedTime);
          let localTotalDuration = new Date(this.totalDuration.getTime() + this.dropOffDuration * 60 * 1000 * (this.estimatedTime.length - 2));
          let totalDurationString = localTotalDuration.toISOString().substr(11, 5).split(':');
          this.totalHours = Number(totalDurationString[0]);
          this.totalMinutes = Number(totalDurationString[1]);
          console.log('this.totalHours');
          console.log(this.totalHours);
          console.log('this.totalMinutes');
          console.log(this.totalMinutes);
        }
        else {
          this.$showAlert(
            'warning',
            "Sorry",
            `Location Not Found`,
          );
          this.journeyTabItems.splice(this.journeyTabItems.findIndex(x => x.title === "Optimized Route"), 1);
        }
      },
      getOptimizedDirections: function(optimizedDirections) {
        // console.log('this.optimizedJourney');
        // console.log(this.optimizedJourney);
        if (optimizedDirections) {
          // console.log('getOptimizedDirections - directions');
          // console.log(optimizedDirections);
          let durations = optimizedDirections['routes'][0]['legs'].map(x => x['duration']['value']);
          let distances = optimizedDirections['routes'][0]['legs'].map(x => x['distance']['value']);
          this.totalDuration2 = new Date(null);
          let durationSum = durations.reduce((a, b) => a + b, 0);
          this.totalDuration2.setSeconds(durationSum);
          this.totalDistance2 = (distances.reduce((a, b) => a + b, 0) / 1000).toFixed(1);
          durations.unshift(0);
          // console.log('durations');
          // console.log(durations);
          durations.reduce((a,b,i) => { return this.cumulativeDurations[i] = a + b; }, 0);
          // console.log('this.cumulativeDurations');
          // console.log(this.cumulativeDurations);
          this.estimatedTimeWODropoff = this.cumulativeDurations.map(x => new Date(this.currentTime.getTime() + x * 1000));
          this.estimatedTime = this.estimatedTimeWODropoff.map(x => x);
          // console.log('this.estimatedTime');
          // console.log(this.estimatedTime);
          for (let i = 1; i < this.estimatedTime.length; i++) {
            this.estimatedTime[i] = new Date(this.estimatedTime[i].getTime() + this.dropOffDuration * 60 * 1000 * (i - 1));
          }
          // console.log('this.estimatedTime - modified');
          // console.log(this.estimatedTime);
          let localTotalDuration = new Date(this.totalDuration2.getTime() + this.dropOffDuration * 60 * 1000 * (this.estimatedTime.length - 2));
          let totalDurationString = localTotalDuration.toISOString().substr(11, 5).split(':');
          this.totalHours2 = Number(totalDurationString[0]);
          this.totalMinutes2 = Number(totalDurationString[1]);
          optimizedDirections['routes'][0]['waypoint_order'] = optimizedDirections['routes'][0]['waypoint_order'].map(x => x + 1);
          optimizedDirections['routes'][0]['waypoint_order'].push(optimizedDirections['routes'][0]['waypoint_order'].length + 1 );
          this.optimizedWaypoints = optimizedDirections['routes'][0]['waypoint_order'];  
          // console.log('this.optimizedWaypoints');
          // console.log(this.optimizedWaypoints);
          // this.optimizedJourney.sort((a,b) => {
          //   return this.optimizedWaypoints2.indexOf(a.key) - this.optimizedWaypoints2.indexOf(b.key);
          // });
          // console.log('this.optimizedJourney - sorted');
          // console.log(this.optimizedJourney);
          
        }
        else {
          this.$showAlert(
            'warning',
            "Sorry",
            `Location Not Found`,
          );
          this.journeyTabItems.splice(this.journeyTabItems.findIndex(x => x.title === "Optimized Route"), 1);
        }
      },
      resetSequence: function() {
        // console.log('this.optimizedWaypoints');
        // console.log(this.optimizedWaypoints);
        // console.log('this.planBottomData');
        // console.log(this.planBottomData['vehicleList'][0]['vehicleItems']['00000247'].map(x => x['DestinationName']));
        let dragOrder = this.locations.map(x => x['key']);
        // console.log('dragOrder');
        // console.log(dragOrder);
        this.planBottomData['vehicleList'].find(x => Object.keys(x['vehicleItems'])[0] === this.journeyTitle)['vehicleItems'][this.journeyTitle]
          .sort((x, y) => dragOrder.indexOf(x.seqNo) - dragOrder.indexOf(y.seqNo));
        this.planBottomData['vehicleList'].find(x => Object.keys(x['vehicleItems'])[0] === this.journeyTitle)['vehicleItems'][this.journeyTitle]
          .forEach((x, i) => {x['seqNo'] = i + 1});
        // console.log(this.planBottomData['vehicleList'][0]['vehicleItems']['00000247'].map(x => x['DestinationName']));
        this.planBottomData['vehicleList'].find(x => Object.keys(x['vehicleItems'])[0] === this.journeyTitle)['vehicleItems'][this.journeyTitle]
          .sort((x, y) => this.optimizedWaypoints.indexOf(x.seqNo) - this.optimizedWaypoints.indexOf(y.seqNo));
        this.planBottomData['vehicleList'].find(x => Object.keys(x['vehicleItems'])[0] === this.journeyTitle)['vehicleItems'][this.journeyTitle]
          .forEach((x, i) => {x['seqNo'] = i + 1});
        // console.log('New Sequence of DropOff Code')
        // console.log(this.planBottomData['vehicleList'][0]['vehicleItems']['00000250'].map(x => x['DropOff']));
        this.closeClicked();
        this.$showAlert('success', 'Journey Updated', 'Click the save button to save the journey.');
      }, 
      journeyTabIndexUpdate: function(tabIndex) {
        if (tabIndex !== this.journeyTabIndex) {
          console.log(`journeyTabIndexUpdate - tabIndex = ${tabIndex}`);
          this.optimizedJourney.sort((a,b) => {
            return this.optimizedWaypoints.indexOf(a.key) - this.optimizedWaypoints.indexOf(b.key);
          });
          this.journeyTabIndex = tabIndex;
          this.$refs.gmap.mRenderRoute(tabIndex);
        }
      },
      timeUpdate: function() {
        if (this.selectedDepartureType === 'leaveNow') {
          this.currentTime = new Date();
          this.currentTimeDisplay = this.currentTime.toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'});
          this.estimatedTime = this.cumulativeDurations.map(x => new Date(this.currentTime.getTime() + x * 1000));
        }
        else if (this.selectedDepartureType === 'departAt') {
          let currentTime  = this.currentTime;
          currentTime.setHours(this.currentTimeDisplay.substr(0, this.currentTimeDisplay.indexOf(":")));
          currentTime.setMinutes(this.currentTimeDisplay.substr(this.currentTimeDisplay.indexOf(":") + 1));
          this.estimatedTime = this.cumulativeDurations.map(x => new Date(this.currentTime.getTime() + x * 1000));
        }
        else if (this.selectedDepartureType === 'arriveBy') {
          let currentTime  = this.currentTime;
          currentTime.setHours(this.currentTimeDisplay.substr(0, this.currentTimeDisplay.indexOf(":")));
          currentTime.setMinutes(this.currentTimeDisplay.substr(this.currentTimeDisplay.indexOf(":") + 1));
          currentTime = new Date(currentTime.getTime() - this.cumulativeDurations[this.cumulativeDurations.length - 1] * 1000);
          this.estimatedTime = this.cumulativeDurations.map(x => new Date(currentTime.getTime() + x * 1000));
        }
      },
      dropOffTimeChange: function() {
        // console.log('dropOffTimeChange');
        // console.log(this.dropOffDuration);
        this.estimatedTime = this.estimatedTimeWODropoff.map(x => x);
        for (let i = 1; i < this.estimatedTime.length; i++) {
          this.estimatedTime[i] = new Date(this.estimatedTime[i].getTime() + this.dropOffDuration * 60 * 1000 * (i - 1));
        }
        let localTotalDuration = new Date(this.totalDuration.getTime() + this.dropOffDuration * 60 * 1000 * (this.estimatedTime.length - 2));
        let totalDurationString = localTotalDuration.toISOString().substr(11, 5).split(':');
        this.totalHours = Number(totalDurationString[0]);
        this.totalMinutes = Number(totalDurationString[1]);
      },
      closeClicked: function() {
        this.journeyView = false;
        this.selectedMetric = 'time';
        this.selectedDepartureType = 'leaveNow';
        this.currentTime = null; 
        this.currentTimeDisplay = null;
        this.journeyTabItems = [{ title: "Original Route" }, { title: "Optimized Route" }];
        this.journeyTabIndex = 0;
        this.journeyTitle = null;
        this.journey = null; 
        this.locations = [];
        this.missingCoordinates =  [];
        this.totalDuration = null;
        this.totalHours = null;
        this.totalMinutes = null;
        this.totalDistance = null;
        this.cumulativeDurations = [];
        this.estimatedTimeWODropoff = [];
        this.optimizedWaypoints = null; 
        this.optimizedJourney = [];
      },
      sharePopup: function(index) {
        this.shareETAPopup = !this.shareETAPopup;
        if (index !== null) {
          this.sharedETA = this.estimatedTime[index].toLocaleTimeString('en-GB', {hour: '2-digit', minute:'2-digit'});
          this.sharedLocation = this.locations[index];
        }
        else {
          this.sharedETA = null;
          this.sharedLocation = null;
        }
      },
      emailShare: function () {
        let details = this.planBottomData['vehicleList'].find(x => Object.keys(x['vehicleItems'])[0] === this.journeyTitle);
        var subject = "Estimated Time of Arrival for " + details["driverDetails"]["drvSel"]["Name"].trim() + " (" + details["vehicleDetails"]["vehNo"] + ")";
        var body = details["driverDetails"]["drvSel"]["Name"].trim() + " (" + details["vehicleDetails"]["vehNo"] + ")" + "'s ETA is " + this.sharedETA + " at " + this.sharedLocation.name;
        var url = "mailto:?subject=" + subject + "&body=" + body;
        window.location.href = url;
      },
      whatsappShare: function () {
        let details = this.planBottomData['vehicleList'].find(x => Object.keys(x['vehicleItems'])[0] === this.journeyTitle);
        var body = details["driverDetails"]["drvSel"]["Name"].trim() + " (" + details["vehicleDetails"]["vehNo"] + ")" + "'s ETA is " + this.sharedETA + " at " + this.sharedLocation.name;
        var url = "https://wa.me/?text=" + body;
        window.open(url, '_blank'); 
      }, 
      telegramShare: function () {
        let details = this.planBottomData['vehicleList'].find(x => Object.keys(x['vehicleItems'])[0] === this.journeyTitle);
        var subject = "Estimated Time of Arrival for " + details["driverDetails"]["drvSel"]["Name"].trim() + " (" + details["vehicleDetails"]["vehNo"] + ")";
        var body = details["driverDetails"]["drvSel"]["Name"].trim() + " (" + details["vehicleDetails"]["vehNo"] + ")" + "'s ETA is " + this.sharedETA + " at " + this.sharedLocation.name;
        var url = "https://t.me/share/url?url=" + subject + body;
        window.open(url, '_blank');
      },

      updateKgM3QtyClicked: function(item, text) {
        item['updating'] = text == 'Update';

        if (text == 'Update') {

        } else {
          item['newWeight'] = item['TB'] ? item['TB'] : (item['BalWeight'] ? item['BalWeight'] : 0),
          item['newM3'] = item['CTN'] ? item['CTN'] : (item['BalM3'] ? item['BalM3'] : 0),
          item['newQty'] = Number(item['newWeight']) + Number(item['newM3'])
        }
        // <div class="title">Quantity</div>
        //   <div class="value">{{ c['Total'] ? c['Total'] : (c['BalQty'] ? c['BalQty'] : '0') }}</div>
        // </div>
        // <div class="row">
        //   <div class="title">Weight</div>
        //   <div class="value">{{ c['TB'] ? c['TB'] : (c['BalWeight'] ? c['BalWeight'] : '0') }}</div>
        // </div>
        // <div class="row">
        //   <div class="title">M3</div>
        //   <div class="value">{{ c['CTN'] ? c['CTN'] : (c['BalM3'] ? c['BalM3'] : '0') }}</div>
        // </div>
      },
      updateKgM3QtySave: async function(item, index) {
        // call api here
        let update = await this.$apiCallV2('/PlanAndAssign/UpdateJITMSDetails', {
          tmsjino: item['TMSJINo'],
          cnno: item['ConsignmentNo'],
          kg: item['newM3'],
          m3: item['newWeight']
        });
        // kg -> m3, m3 -> kg

        if (update[0]['Results'] == 0) {
          let qtyKey = item['Total'] ? 'Total' : (item['BalQty'] ? 'BalQty' : '');
          let weightKey = item['TB'] ? 'TB' : (item['BalWeight'] ? 'BalWeight' : '');
          let m3Key = item['CTN'] ? 'CTN' : (item['BalM3'] ? 'BalM3' : '');

          item[qtyKey] = item['newQty'];
          item[weightKey] = item['newWeight'];
          item[m3Key] = item['newM3'];

          let newTotalQty = this.vehicleDetailsListSel['Consignments'].map(v => Number(v[qtyKey])).reduce((a, b) => a + b);
          let newTotalWeight = this.vehicleDetailsListSel['Consignments'].map(v => Number(v[weightKey])).reduce((a, b) => a + b);
          let newTotalM3 = this.vehicleDetailsListSel['Consignments'].map(v => Number(v[m3Key])).reduce((a, b) => a + b);
          
          this.vehicleDetailsListSel['Qty'] = newTotalQty;
          this.vehicleDetailsListSel['Weight'] = newTotalWeight;
          this.vehicleDetailsListSel['M3'] = newTotalM3;

          item['updating'] = false;
          
          let allRoutes = this.planBottomData['vehicleList'][this.vehicleItemRowIndex]['vehicleItems'][item['TMSJINo']];
          let selectedRoute = allRoutes.find(a => a['JobNo'].trim() == item['JobNo'].trim());
          selectedRoute['Qty'] = newTotalQty;
          selectedRoute['Weight'] = newTotalWeight;
          selectedRoute['M3'] = newTotalM3;

          selectedRoute['Consignments'][index][qtyKey] = item['newQty'];
          selectedRoute['Consignments'][index][weightKey] = item['newWeight'];
          selectedRoute['Consignments'][index][m3Key] = item['newM3'];
        } else {

        }
      },
      newValueChanged: function(item) {
        item['newQty'] = Number(item['newWeight']) + Number(item['newM3']);
      }
    },
    watch: {
      printSelectShow: function(val) {
        if (val) {
          this.selectedPrintFormat = this.printFormatList[0];
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

  .planassignMain {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    background-color: #ffff;
    border: solid 1px #000F;
    overflow: hidden;

    > .designerv2-popup {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      padding: 10px 45px;
      background-color: rgba(0,0,0,0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;

      > :first-child {
        background-color: white;
      }
    }
  }

  .planResize {
    width: auto;
    height: 4px;
    margin: 4px 0;
    position: absolute;
    left: 50px;
    right: 10px;
    background-color: #000000;
    border: solid 1px #000000;
    cursor: n-resize;
  }

  .planTop {
    width: auto;
    height: auto;
    position: absolute;
    top: 10px;
    left: 50px;
    right: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background-color: #ffff;
    overflow-y: hidden;
  }

  .planBottom {
    width: auto;
    height: auto;
    position: absolute;
    bottom: 10px;
    left: 50px;
    right: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background-color: #ffff;
  }

  .planDragCover {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    transition: 0.3s;
    z-index: 5;
  }

  .tooltipMove {
    width: auto;
    height: auto;
    min-width: 160px;
    padding: 5px;
    font-size: 12px;
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 0 8px #0008;
    z-index: 20;

    > .row {
      width: 100%;
      height: auto;
    }

    > .details {
      width: 100%;
      height: auto;
      margin: 10px 0 0 0;
    }
  }

  .planLoader {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 2000;

    > .msgBox {
      width: auto;
      height: 40px;
      padding: 10px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;
      user-select: none;
    }
  }

  .planTopFilter {
    width: 350px;
    min-width: 350px;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    > .planTopFunctions {
      width: 100%;
      height: auto;
      min-height: 240px;
      padding: 5px 5px 0 5px;
      margin: 0 0 5px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border: solid 1px #0004;
      white-space: nowrap;

      > .functions {
        width: 100%;
        height: auto;
        margin: 0 0 5px 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        > button {
          height: 100%;
          margin: 0 4px 0 0;
        }
      }

      > .tableCheckbox {
        width: auto;
        height: 25px;
        margin: 5px 0 0 0;
        font-size: 12px;
      }

      > .row {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .input {
          width: auto;
          flex: 1;
        }

        > .rowDropdown {
          width: auto;
          max-width: 48%;
          flex: 1;
        }

        > button {
          width: 30px;
          margin: 0 0 0 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > .row {
          width: 52.5%;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .input {
            width: auto;
            flex: 1;
          }

          > button {
            width: 30px;
            margin: 0 0 0 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
    
    > .planTopFilterList {
      width: 100%;
      height: auto;
      padding: 5px 5px 0 5px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border: solid 1px #0004;
      overflow: scroll;
      
      > .planTopFilterMain {
        width: 100%;
        height: auto;
        margin: 0 0 5px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #b3c4ff;
        border-radius: 4px;

        > .header {
          width: 100%;
          height: 24px;
          min-height: 24px;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          user-select: none;
          cursor: pointer;

          > .title {
            width: auto;
            height: 100%;
            padding: 0 5px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }

          > .functions {
            width: 24px;
            height: 24px;
            min-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        > .content {
          width: 100%;
          height: auto;
          padding: 0 5px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;

          > .filterMain {
            width: 100%;
            height: 22px;
            min-height: 22px;
            margin: 0 0 4px 0;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            background-color: #e9e9e9;
            cursor: pointer;
            
            > .filterItem, .filterOption, .filterCount {
              height: 100%;
              padding: 0 4px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              user-select: none;
              white-space: nowrap;
              overflow: hidden;
            }

            > .filterItem, .filterOption {
              width: 40%;
            }

            > .filterCount {
              width: auto;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          > .filterMain:hover {
            background-color: #ffffff;
          }
        }
      }

      > .planTopFilterMsg {
        width: 100%;
        height: auto;
        flex: 1;
        font-size: 12px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
      }
    }
  }

  .planTopTableMain {
    width: auto;
    height: 100%;
    margin: 0 0 0 5px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    > .planTopDetailsMain {
      width: 100%;
      height: auto;
      margin: 0 0 5px 0;
      padding: 0 0 0 5px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      border: solid 1px #0004;

      > .planTopDetails {
        width: auto;
        height: auto;
        margin: 0 5px 0 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        > .planTopDetailsRow {
          width: 100%;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .title {
            width: 150px;
            height: 100%;
            font-size: 12px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
          }

          > .value {
            width: auto;
            height: 100%;
            padding: 0 5px;
            font-size: 12px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }

    > .planTopTable {
      width: 100%;
      height: auto;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      
      > .tableMain {
        width: 100%;
        height: auto;
        min-height: 172px;
        flex: 1;
        position: relative;
        background-color: #ffffff;
        z-index: 10;

        > .tableFunctions {
          width: auto;
          height: 35px;
          position: absolute;
          top: 0px;
          right: 150px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          z-index: 2000;

          > button {
            margin: 0 5px 0 0;
          }
        }

        > .table {
          width: auto;
          height: calc(100%);
          font-size: 12px;
          position: absolute;
          top: 0px;
          left: 0px;
          right: 0px;
          user-select: none;
        }
      }

      > .tableTopFunctions {
        width: 100%;
        height: auto;
        margin: 0 0 5px 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        > button {
          height: 100%;
          margin: 0 5px 0 0;
        }

        > button:focus {
          box-shadow: none;
        }
      }
      
      > .tableBottomFunctions {
        width: 100%;
        height: auto;
        margin: 5px 0 0 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > button:focus {
          box-shadow: none;
        }
      }
    }
  }

  .planBottomFilter {
    width: 350px;
    height: 100%;
    min-width: 350px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    
    
    > .planBottomFunctions {
      width: 100%;
      height: 70px;
      min-height: 70px;
      padding: 5px 5px 0 5px;
      margin: 0 0 5px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border: solid 1px #0004;
      white-space: nowrap;

      > .functions {
        width: 100%;
        height: auto;
        margin: 0 0 5px 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        > button {
          height: 100%;
          margin: 0 4px 0 0;
        }
      }

      > .row {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    
    > .planBottomFilterList {
      width: 100%;
      height: auto;
      padding: 5px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border: solid 1px #0004;
      overflow: scroll;
      
      > .planBottomFilterMain {
        width: 100%;
        height: auto;
        margin: 0 0 4px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #c6e6c1;
        border-radius: 4px;

        > .header {
          width: 100%;
          height: 24px;
          min-height: 24px;
          padding: 0 0 0 4px;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          user-select: none;
          cursor: pointer;

          > .vehicleCheck {
            width: 15px;
            height: 15px;
            margin: 0 2px 0 0;
            font-size: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #ffffff;
            border: solid 1px #bbb;
            border-radius: 15px;
          }

          > .title {
            width: auto;
            height: 100%;
            padding: 0 5px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }

          .vehicleCount {
            width: auto;
            height: 100%;
            margin: 0 4px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          > .functions {
            width: 24px;
            height: 24px;
            min-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        
        > .content {
          width: 100%;
          height: auto;
          padding: 0 5px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;

          > .vehicleMain {
            width: 100%;
            height: 22px;
            min-height: 22px;
            padding: 0 0 0 2px;
            margin: 0 0 4px 0;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            background-color: #e9e9e9;
            cursor: pointer;

            > .vehicleCheck {
              width: 15px;
              height: 15px;
              margin: 0 2px 0 0;
              font-size: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #ffffff;
              border: solid 1px #bbb;
              border-radius: 15px;
            }
            
            > .vehicleDesc, .vehicleType, .vehicleCount {
              height: 100%;
              padding: 0 4px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              user-select: none;
              white-space: nowrap;
              overflow: hidden;
            }

            > .vehicleDesc {
              width: 65%;
            }

            > .vehicleType {
              width: 20%;
            }

            > .vehicleCount {
              width: auto;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          > .vehicleMain:hover {
            background-color: #ffffff;
          }
        }
      }
      
      > .planBottomFilterMsg {
        width: 100%;
        height: auto;
        flex: 1;
        font-size: 12px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
      }
    }
  }

  .planBottomVehicleListMain {
    width: auto;
    max-width: calc(100% - 355px);
    height: 100%;
    margin: 0 0 0 5px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .planBottomVehicleFunctions {
    width: 100%;
    height: 40px;
    padding: 5px;
    margin: 0 0 5px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: solid 1px #0004;

    > .planBottomVehicleLegend {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      > .item {
        width: auto;
        height: 100%;
        margin: 0 10px 0 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .color {
          width: 20px;
          height: 20px;
          margin: 0 2px 0 0;
          border: solid 1px #0004;
          border-radius: 3px;
        }

        > .title {
          width: auto;
          height: 100%;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
      }
    }

    > .planBottomVehicleButtonList {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > button {
        margin: 0 0 0 5px;
      }
    }
  }

  .planBottomVehicleList {
    width: 100%;
    height: auto;
    padding: 5px 5px 0 5px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffffff;
    border: solid 1px #0004;
    overflow: auto;
    z-index: 10;

    > .vehicleItemMain {
      width: 100%;
      height: auto;
      padding: 5px 0 5px 5px;
      margin: 0 0 5px 0;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      background-color: #f2f1b8;
      border: solid 1px gray;

      > .vehicleDetails {
        width: auto;
        height: 100%;
        padding: 0 5px;
        margin: 0 5px 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #ffffff;
        border: solid 1px lightgray;
        
        > .item {
          width: 100%;
          height: 20px;
          margin: 2px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .icon {
            width: 20px;
            height: 20px;
            margin: 0 10px 0 0;
          }

          > .value {
            width: auto;
            height: 100%;
            font-size: 12px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
        }
      }

      > .vehicleItemList {
        width: auto;
        height: 100%;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        > .vehicleJourneyList {
          width: auto;
          height: 100%;
          min-height: 150px;
          padding: 4px 0 4px 60px; 
          margin: 0 5px 0 0;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          white-space: nowrap;
          background-color: #eeeeee;
          border: solid 1px lightgray;

          > .journeyTitle {
            width: 100px;
            height: 20px;
            min-height: 20px;
            max-height: 20px;
            font-size: 14px;
            font-weight: bold;
            line-height: 16px;
            position: absolute;
            left: -40px;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: rotate(-90deg);
            user-select: none;
            pointer-events: none;
            border-bottom: solid 1px lightgray;
          }

          
          > .vehicleDetailsButton {
            margin: 5px;
            transform: rotate(-90deg);
            position: absolute;
            left: -30px;

            > .mapButton {
              
              > .mapButtonImage {
                height: 20px;
                margin-right: 6px;
              }
            }
          }
        
          > .vehicleItem {
            width: auto;
            height: 100%;
            min-width: 150px;
            max-width: 150px;
            padding: 5px;
            margin: 0 4px 0 0;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            background-color: #ffffff;
            border: solid 1px lightgray;
            cursor: pointer;
            user-select: none;

            > .details {
              width: auto;
              height: 100%;
              min-width: calc(100% - 20px);
              max-width: calc(100% - 20px);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              pointer-events: none;

              > .row {
                width: 100%;
                height: auto;
                font-size: 10px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                white-space: nowrap;
                pointer-events: none;
                overflow: hidden;
              }

              > .list {
                width: 100%;
                height: 42px;
                min-height: 42px;
                margin: 4px 0 0 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                pointer-events: all;
                overflow-y: scroll;

                > .row {
                  width: 100%;
                  height: 14px;
                  min-height: 14px;
                  max-height: 14px;
                  padding: 0 2px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  white-space: nowrap;
                  overflow: hidden;

                  > .text {
                    width: auto;
                    height: 100%;
                    font-size: 10px;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    pointer-events: none;
                  }

                  > .remove {
                    width: 14px;
                    height: 14px;
                    min-width: 14px;
                    max-width: 14px;
                    min-height: 14px;
                    max-height: 14px;
                    font-size: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    pointer-events: all;
                  }

                  > .remove:hover {
                    font-weight: bold;
                    color: red;
                  }
                }
              }
            }

            > .functions {
              width: 20px;
              height: 100%;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-between;
              pointer-events: none;

              > .remove {
                width: 16px;
                height: 16px;
                min-width: 16px;
                min-height: 16px;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 16px;
                user-select: none;
                pointer-events: all;
                cursor: pointer;
              }

              > .remove:hover {
                font-weight: bold;
                color: red;
              }

              > .seqNo {
                width: 100%;
                height: auto;
                padding: 0 0 5px 0;
                font-size: 14px;
                font-weight: bold;
                flex: 1;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                user-select: none;
                pointer-events: none;
              }
            }
          }
        }
      }

      > .vehicleItem:hover {
        background-color: #eeeeee;
      }
      

      > .vehicleItemFunctions {
        width: auto;
        height: 100%;
        margin: 0 0 0 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        > button {
          width: 100%;
          margin: 0 0 5px 0;
        }
      }
    }
    
    > .vehicleItemEmpty {
      width: 100%;
      height: 100%;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
    }
  }

  .vehicleItemPopupMain {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color:#00000088;
    z-index: 99995;

    > .vehicleItemPopup {
      width: 100%;
      height: 100%;
      max-width: 500px;
      max-height: 600px;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;
      
      > .header {
        width: 100%;
        height: 30px;
        padding: 0 5px 0 0;
        margin: 0 0 5px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .title {
          width: auto;
          height: 100%;
          font-size: 16px;
          font-weight: bold;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        > .remove {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          user-select: none;
          cursor: pointer;
        }
        
        > .remove:hover {
          color: red;
          font-weight: bold;
        }
      }

      > .body {
        width: 100%;
        height: auto;
        padding: 0 5px 5px 5px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        overflow-y: auto;

        > .row {
          width: 100%;
          height: 17px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .title {
            width: 120px;
            height: 100%;
            font-weight: bold;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
          }
          
          > .value {
            width: auto;
            height: 100%;
            flex: 1;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
          }
        }

        > .consignment {
          width: 100%;
          height: auto;
          padding: 5px;
          margin: 10px 0 0 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          border-radius: 4px;
          border: solid 1px #0004;
          box-shadow: 0 0 5px #0008;
          position: relative;

          > .header {
            width: 100%;
            height: 18px;
            margin: 0 0 5px 0;
            font-size: 13px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }

          > .row {
            width: 100%;
            height: 12px;
            font-size: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            > .title {
              width: 120px;
              height: 100%;
              font-weight: bold;
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
            }
            
            > .value {
              width: auto;
              height: 100%;
              flex: 1;
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
            }
          }
          
          > .update-button {
            position: absolute;
            bottom: 5px;
            right: 5px;

            > .save, > .cancel {
              margin-left: 5px;
              font-size: 10px;

              > img {
                height: 15px;
                width: 15px;
              }
            }
          }
        }
      }
    }
  }

  .savePopupMain {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color:#00000088;
    z-index: 99999;

    > .savePopup {
      width: 100%;
      height: 100%;
      max-width: 500px;
      max-height: 200px;
      padding: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;

      > .header {
        width: 100%;
        height: 30px;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      > .body {
        width: 100%;
        height: auto;
        padding: 5px;
        font-size: 12px;
        flex: 1;
      }

      > .functions {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > button {
          margin: 0 0 0 5px;
        }
      }
    }
  }

  .designerPopUpMain {
    width: 100%;
    height: 100%;
    padding: 20px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color:#00000088;
    z-index: 99999;

    > .designerPopUp {
      width: 90%;
      height: 100%;
    }
  }

  .printSelectPopUpMain {
    width: 100%;
    height: 100%;
    padding: 20px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color:#00000088;
    z-index: 99998;

    > .printSelectPopUp {
      width: 400px;
      height: 400px;
      padding: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      background-color: #ffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;

      > .header {
        width: 100%;
        height: 30px;
        margin: 0 0 5px 0;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      > .body {
        width: 100%;
        height: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        overflow: auto;

        > .printSelectMsg {
          width: 100%;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > .printSelectItem {
          width: 100%;
          height: auto;
          padding: 5px;
          margin: 0 0 5px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          background-color: #ffffff;
          border: solid 1px lightgray;
          user-select: none;
          cursor: pointer;

          > .header {
            width: 100%;
            height: 20px;
            font-size: 14px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          > .details {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;

            > .item {
              width: 100%;
              height: 20px;
              margin: 2px 0;
              display: flex;
              align-items: center;
              justify-content: space-between;

              > .icon {
                width: 20px;
                height: 20px;
                margin: 0 10px 0 0;
              }

              > .value {
                width: 30%;
                height: 100%;
                font-size: 12px;
                // flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-start;
              }

              > .value2 {
                width: 70%;
                height: 100%;
                font-size: 12px;
                // flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-start;
              }
            }
          }
          
        }

        > .printSelectItem:hover {
          border: solid 1px gray;
        }
      }

      > .functions {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > button {
          margin: 0 0 0 5px;
        }
      }
    }
  }

  .mapFunctionDisplay {
    position: relative;

    > .wrapper {
      padding: 10px;
      height: 80vh;
    }

    > .listView {
      position: absolute;
      z-index: 99999;
      height: auto;
      background: white;
      width: 370px;

      > .journeyTabs {
        font-size: 12px;
      }
    }

    > .mapView {
      width: 100%;
    }
  }

  .mapFunctionDisplay::after {
    content: "";
    display: table;
    clear: both;
  }

  .originalRouteTab {
    height: 100%; 

    > .dropOffDurationDiv {
      white-space: nowrap;

      > .dropOffDurationInput {
        width: 40px;
      }
    }

    > .totalDisplayDiv {
      margin-bottom: 5px;
    }

    > .destinationList {
      display: flex;
      white-space: nowrap;

      > .indexDiv {
        display: inline-block;
        width: 6%;
      }

      > .locationInputComp {
        display: inline-block;
        width: 75%;
        margin-right: 5px;
        white-space: initial;
        margin-bottom: 4px;
      }

      > .timeDisplayDiv {
        display: inline-block;
        margin-right: 10px;
        font-size: 11px;
      }

      > .shareButtonDiv {
        display: inline-block;

        > .shareButton {
          width: 10px;
          height: 10px;
          cursor: pointer;

          > img {
            width: 10px;
            height: 10px;
          }
        }
      }
    }
    
  }

  .optimizedRouteTab {
    height: 100%;

    > .departureDiv {
      display: flex;

      > .clockIconDiv {
        
        > img {
          height: 20px;
        }
      }

      > .routeTypeList {
        margin-bottom: 2px;

        > .departureType {
          border-color: transparent;
        }
      }

      > .timeInputDisplay {
        margin-left: 4px;
        margin-bottom: 5px;
      }
    }

    > .destinationContainer {
      margin-top: 10px;

      > .destinationList {
        display: flex;
        white-space: nowrap;

        > .indexDiv {
          display: inline-block;
          width: 6%;
        }

        > .locationInputComp {
          display: inline-block;
          width: 75%;
          margin-right: 5px;
          white-space: initial;
          margin-bottom: 4px;
        }

        > .timeDisplayDiv {
          display: inline-block;
          margin-right: 10px;
          font-size: 11px;
        }

        > .shareButtonDiv {
          display: inline-block;

          > .shareButton {
            width: 10px;
            height: 10px;
            cursor: pointer;

            > img {
              width: 10px;
              height: 10px;
            }
          }
        }
      }
    }
  }

  .share-selection {
    position: fixed;
    width: 100%;
    height: 100%;
    padding-top: 50px;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 99999;

    > .share-popup-title {
      width: 100%;
      max-width: 30%;
      background-color: white;
      padding: 10px 0;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
    }

    > .share-popup-container {
      background-color: white;
      width: 100%;
      max-width: 30%;
      max-height: 60%;
      padding: 10px;
      overflow: auto;
      display: flex;
      justify-content: space-between;
    }

    > .share-cancel {
      background-color: white;
      width: 100%;
      max-width: 30%;
      max-height: 60%;
      padding: 10px;
      overflow: auto;
      display: flex;
      justify-content: center;
    }
  }

  .tab-details {
    text-align: left;
    margin-top: 2px;
    font-size: 9px;
  }

</style>